import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../UI/Loader'
import LangSelector from '../UI/LangSelector'
import connexion from '../../connexion'
import './ServiceWizard.css'

const MAX_FAMILIES = 8
const MAX_FAMILY_NAME = 30

function makeFamily(name, order, lang) {
	return { id: Date.now().toString(36) + Math.random().toString(36).slice(2), order, translations: [{ lang, name }] }
}

const DAYS = [
	{ key: 'monday', label: 'L', full: 'Lun' },
	{ key: 'tuesday', label: 'M', full: 'Mar' },
	{ key: 'wednesday', label: 'Me', full: 'Mer' },
	{ key: 'thursday', label: 'J', full: 'Jeu' },
	{ key: 'friday', label: 'V', full: 'Ven' },
	{ key: 'saturday', label: 'S', full: 'Sam' },
	{ key: 'sunday', label: 'D', full: 'Dim' }
]

const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']

const EMPTY_CRENEAU = {
	monday: false, tuesday: false, wednesday: false,
	thursday: false, friday: false, saturday: false, sunday: false,
	start_hour: 9, start_minute: 0, end_hour: 10, end_minute: 0
}

const EMPTY_DATE = { start_day: 1, start_month: 7, end_day: 31, end_month: 8 }

const stripHtml = (html) => (html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').trim()

class ServiceDetail extends Component {
	constructor(props) {
		super(props)
		this.iconPickerRef = React.createRef()
		this.coverInputRef = React.createRef()
		this.productImageRef = React.createRef()
		this.state = {
			service: null,
			benefits: null,
			workers: null,
			loading: true,
			pageError: null,
			icons: null,
			theme: null,

			current_lang: this.props.lang_default,

			// Benefit wizard
			showBenefitWizard: false,
			benefitStep: 1,
			benefitForm: this._emptyBenefitForm(),
			creneauForm: { ...EMPTY_CRENEAU },
			dateForm: { ...EMPTY_DATE },
			benefitLoading: false,
			benefitError: null,
			showVenteDelays: false,
			showVenteSubSlots: false,

			// Worker inline form
			showWorkerForm: false,
			workerForm: { firstname: '', lastname: '' },
			workerLoading: false,
			workerError: null,

			// Worker edit form
			editingWorkerId: null,
			workerEditForm: null,
			workerEditLoading: false,
			workerEditError: null,

			// Delete confirm
			deleteConfirm: null,

			// Edit mode
			editingBenefitId: null,
			editingCreneauIndex: null,
			showCreneauForm: false,
			editingDateIndex: null,
			showDateForm: false,

			showIconPicker: false,

			// Question form
			showQuestionForm: false,
			questionForm: { translations: [], type: '', mandatory: false },
			editingQuestionIndex: null,

			// Products (vente)
			products: [],
			productForm: { translations: [], price: '', stock: '', image: null, family: null },
			productLoading: false,
			productError: null,
			productImageUploading: false,
			showProductForm: false,
			editingProductId: null,
			deleteProductConfirm: null,
			dragSourceId: null,
			dragOverId: null,

			// Families (vente)
			familyEditId: null,
			familyEditValue: '',
			familyEditError: null,
			familyDeleteConfirm: null,
			familyAddInput: '',
			familyAddError: null,
			familyAddShow: false,
			familyDragSourceId: null,
			familyDragOverId: null,
			familySaving: false,

			// Header edit
			editingHeader: false,
			headerForm: { name: '', cover: '' },
			headerLoading: false,
			headerError: null,

			// Paiement in-app (visible si le compte Stripe du camping est actif)
			stripe_ready: false,
			paymentModeLoading: false,
			paymentModeError: null,

			// Montant minimum du panier pour proposer la CB en mode "cb_optional"
			// (null = non édité, on dérive l'affichage de la valeur du service)
			paymentMinEnabled: null,
			paymentMinInput: null,
			paymentMinLoading: false,
			paymentMinError: null,

			// Montant maximum du panier, à partir duquel la CB est imposée en mode
			// "cb_optional" (même logique d'édition que le montant minimum).
			paymentMaxEnabled: null,
			paymentMaxInput: null,
			paymentMaxLoading: false,
			paymentMaxError: null
		}
	}

	_emptyBenefitForm() {
		return {
			translations: [],
			duration_hour: (this.state && this.state.service && this.state.service.type === 'vente') ? 0 : 1,
			duration_minute: 0,
			interval_hour: 0,
			interval_minute: 0,
			open_hours: [],
			open_dates: [],
			max_participants: 10,
			participants_unlimited: (this.state && this.state.service && this.state.service.type === 'vente') ? true : false,
			price: '',
			questions: [],
			icon: null,
			selectedWorkerIds: [],
			limit_end_h: (this.state && this.state.service && this.state.service.limit_end != null) ? Math.floor(Number(this.state.service.limit_end)) : 0,
			limit_end_m: (this.state && this.state.service && this.state.service.limit_end != null) ? Math.round((Number(this.state.service.limit_end) % 1) * 60) : 0,
			cancel_limit_h: (this.state && this.state.service && this.state.service.cancel_limit != null) ? Math.floor(Number(this.state.service.cancel_limit)) : 0,
			cancel_limit_m: (this.state && this.state.service && this.state.service.cancel_limit != null) ? Math.round((Number(this.state.service.cancel_limit) % 1) * 60) : 0,
			client_number: false,
			identity: true,
			age: false,
			phone: false
		}
	}

	componentDidMount() {
		const id = this.props.match.params.id
		this.props.updateNavbarTitle('Fiche service')

		this.props.fetchServices()
			.then(services => {
				const service = services.find(s => s._id === id)
				if (!service) {
					this.setState({ loading: false, pageError: 'Service introuvable.' })
					return null
				}
				this.setState({ service })
				const promises = [this.props.fetchServiceBenefitsByService(id)]
				if (service.type === 'prestation')
					promises.push(this.props.fetchServiceWorkersByService(id))
				return Promise.all(promises)
			})
			.then(results => {
				if (!results) return
				const benefits = results[0] || []
				const workers = results[1] || []
				const locationState = this.props.location && this.props.location.state
				const autoOpen = locationState && locationState.openBenefitWizard
				const prefillTitle = (locationState && locationState.serviceTitle) || ''
				if (autoOpen) {
					this.props.history.replace(this.props.location.pathname)
					this.setState({
						benefits, workers, loading: false,
						showBenefitWizard: true,
						benefitForm: { ...this._emptyBenefitForm(), translations: prefillTitle ? [{ lang: this.state.current_lang, subtitle: prefillTitle, location: '', description: '' }] : [] }
					}, () => this.loadProducts())
				} else {
					this.setState({ benefits, workers, loading: false }, () => this.loadProducts())
				}
			})
			.catch(() => {
				this.setState({ loading: false, pageError: 'Impossible de charger le service.' })
			})

		Promise.all([this.props.fetchIcons(), this.props.fetchTheme()])
			.then(([icons, theme]) => {
				this.setState({ icons, theme })
			})
			.catch(() => {})

		this.props.fetchStripeStatus()
			.then(status => {
				const stripe_ready = (status && status.connected === true && status.charges_enabled === true)
				this.setState({ stripe_ready })
			})
			.catch(() => {})
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.showIconPicker && !prevState.showIconPicker) {
			document.addEventListener('mousedown', this.handleIconPickerOutsideClick)
		} else if (!this.state.showIconPicker && prevState.showIconPicker) {
			document.removeEventListener('mousedown', this.handleIconPickerOutsideClick)
		}
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleIconPickerOutsideClick)
	}

	handleIconPickerOutsideClick = (e) => {
		if (this.iconPickerRef.current && !this.iconPickerRef.current.contains(e.target)) {
			this.setState({ showIconPicker: false })
		}
	}

	// ─── Benefit wizard ──────────────────────────────────────────────────────────

	openBenefitWizard = () => {
		const { service, benefits, current_lang } = this.state
		// Pré-remplir avec le nom du service si c'est la première prestation
		let subtitle = ''
		if (!benefits || benefits.length === 0) {
			const lang = current_lang
			subtitle = service.name
			if (service.translations) {
				for (let i = 0; i < service.translations.length; i++) {
					if (service.translations[i].lang === lang && service.translations[i].title) {
						subtitle = service.translations[i].title
						break
					}
				}
			}
		}
		const translations = subtitle ? [{ lang: current_lang, subtitle, location: '', description: '' }] : []
		this.setState({
			showBenefitWizard: true,
			editingBenefitId: null,
			benefitStep: 1,
			showIconPicker: false,
			benefitForm: { ...this._emptyBenefitForm(), translations },
			creneauForm: { ...EMPTY_CRENEAU },
			dateForm: { ...EMPTY_DATE },
			showQuestionForm: false,
			questionForm: { translations: [], type: '', mandatory: false },
			editingQuestionIndex: null,
			showVenteSubSlots: false,
			benefitError: null
		})
	}

	openEditBenefitWizard = (benefit) => {
		const service = this.state.service
		const translations = (benefit.translations || []).map(t => ({
			...t,
			description: stripHtml(t.description || '')
		}))
		this.setState({
			showBenefitWizard: true,
			editingBenefitId: benefit._id,
			benefitStep: 1,
			showIconPicker: false,
			benefitForm: {
				translations,
				icon: benefit.icon || null,
				duration_hour: benefit.duration_hour != null ? benefit.duration_hour : (service && service.type === 'vente' ? 0 : 1),
				duration_minute: benefit.duration_minute != null ? benefit.duration_minute : 0,
				interval_hour: benefit.interval_hour != null ? benefit.interval_hour : 0,
				interval_minute: benefit.interval_minute != null ? benefit.interval_minute : 0,
				open_hours: (benefit.open_hours || []).map(c => ({ ...c })),
				open_dates: (benefit.open_dates || []).map(d => ({ ...d })),
				max_participants: benefit.simultaneous != null ? benefit.simultaneous : 10,
				participants_unlimited: benefit.simultaneous === null,
				price: benefit.price || '',
				questions: (benefit.questions || []).map(q => ({ ...q })),
				selectedWorkerIds: (this.state.workers || []).filter(w => w.services.indexOf(benefit._id) !== -1).map(w => w._id),
				limit_end_h: Math.floor(Number(benefit.limit_end != null ? benefit.limit_end : (service && service.limit_end != null ? service.limit_end : 0))),
				cancel_limit_h: Math.floor(Number(benefit.cancel_limit != null ? benefit.cancel_limit : (service && service.cancel_limit != null ? service.cancel_limit : 0))),
				cancel_limit_m: Math.round((Number(benefit.cancel_limit != null ? benefit.cancel_limit : (service && service.cancel_limit != null ? service.cancel_limit : 0)) % 1) * 60),
				limit_end_m: Math.round((Number(benefit.limit_end != null ? benefit.limit_end : (service && service.limit_end != null ? service.limit_end : 0)) % 1) * 60),
				client_number: benefit.client_number || false,
				identity: benefit.identity != null ? benefit.identity : true,
				age: benefit.age || false,
				phone: benefit.phone || false
			},
			creneauForm: { ...EMPTY_CRENEAU },
			dateForm: { ...EMPTY_DATE },
			showQuestionForm: false,
			questionForm: { translations: [], type: '', mandatory: false },
			editingQuestionIndex: null,
			showVenteSubSlots: !!(service && service.type === 'vente' && (benefit.duration_hour > 0 || benefit.duration_minute > 0)),
			showVenteDelays: !!(service && service.type === 'vente' && (benefit.limit_end > 0 || benefit.cancel_limit > 0)),
			benefitError: null
		})
	}

	closeBenefitWizard = () => {
		this.setState({ showBenefitWizard: false, benefitError: null })
	}

	setBenefitField = (field, value) => {
		this.setState({ benefitForm: { ...this.state.benefitForm, [field]: value }, benefitError: null })
	}

	toggleDay = (day) => {
		this.setState({
			creneauForm: { ...this.state.creneauForm, [day]: !this.state.creneauForm[day] }
		})
	}

	setCreneauField = (field, value) => {
		this.setState({ creneauForm: { ...this.state.creneauForm, [field]: value } })
	}

	setDateField = (field, value) => {
		this.setState({ dateForm: { ...this.state.dateForm, [field]: value } })
	}

	editCreneau = (index) => {
		const c = this.state.benefitForm.open_hours[index]
		this.setState({ creneauForm: { ...c }, editingCreneauIndex: index, showCreneauForm: true, benefitError: null })
	}

	addCreneau = () => {
		const { creneauForm, benefitForm, editingCreneauIndex } = this.state
		if (!DAYS.some(d => creneauForm[d.key])) {
			this.setState({ benefitError: 'Sélectionnez au moins un jour.' })
			return
		}
		const open_hours = [...benefitForm.open_hours]
		if (editingCreneauIndex !== null) {
			open_hours[editingCreneauIndex] = { ...creneauForm }
		} else {
			open_hours.push({ ...creneauForm })
		}
		this.setState({
			benefitForm: { ...benefitForm, open_hours },
			creneauForm: { ...EMPTY_CRENEAU },
			editingCreneauIndex: null,
			showCreneauForm: false,
			benefitError: null
		})
	}

	cancelEditCreneau = () => {
		this.setState({ creneauForm: { ...EMPTY_CRENEAU }, editingCreneauIndex: null, showCreneauForm: false, benefitError: null })
	}

	removeCreneau = (index) => {
		const open_hours = [...this.state.benefitForm.open_hours]
		open_hours.splice(index, 1)
		const { editingCreneauIndex } = this.state
		this.setState({
			benefitForm: { ...this.state.benefitForm, open_hours },
			editingCreneauIndex: editingCreneauIndex === index ? null : editingCreneauIndex,
			showCreneauForm: editingCreneauIndex === index ? false : this.state.showCreneauForm,
			creneauForm: editingCreneauIndex === index ? { ...EMPTY_CRENEAU } : this.state.creneauForm
		})
	}

	editDate = (index) => {
		const d = this.state.benefitForm.open_dates[index]
		this.setState({ dateForm: { ...d }, editingDateIndex: index, showDateForm: true, benefitError: null })
	}

	cancelEditDate = () => {
		this.setState({ dateForm: { ...EMPTY_DATE }, editingDateIndex: null, showDateForm: false, benefitError: null })
	}

	addDateRange = () => {
		const { dateForm, benefitForm, editingDateIndex } = this.state
		const parsedDate = {
			start_day: parseInt(dateForm.start_day) || 1,
			start_month: Math.min(12, Math.max(1, parseInt(dateForm.start_month) || 1)),
			end_day: parseInt(dateForm.end_day) || 1,
			end_month: Math.min(12, Math.max(1, parseInt(dateForm.end_month) || 1))
		}
		const open_dates = [...benefitForm.open_dates]
		if (editingDateIndex !== null) {
			open_dates[editingDateIndex] = parsedDate
		} else {
			open_dates.push(parsedDate)
		}
		this.setState({
			benefitForm: { ...benefitForm, open_dates },
			dateForm: { ...EMPTY_DATE },
			editingDateIndex: null,
			showDateForm: false,
			benefitError: null
		})
	}

	removeDateRange = (index) => {
		const open_dates = [...this.state.benefitForm.open_dates]
		open_dates.splice(index, 1)
		const { editingDateIndex } = this.state
		this.setState({
			benefitForm: { ...this.state.benefitForm, open_dates },
			editingDateIndex: editingDateIndex === index ? null : editingDateIndex,
			showDateForm: editingDateIndex === index ? false : this.state.showDateForm,
			dateForm: editingDateIndex === index ? { ...EMPTY_DATE } : this.state.dateForm
		})
	}

	nextBenefitStep = () => {
		const { benefitStep, benefitForm, service } = this.state
		const isVente = service && service.type === 'vente'
		if (benefitStep === 1) {
			const defaultTrans = (benefitForm.translations || []).find(t => t.lang === this.props.lang_default)
			if (!defaultTrans || !defaultTrans.subtitle.trim()) {
				this.setState({ benefitError: 'Le titre est requis (version ' + this.props.lang_default.toUpperCase() + ').' })
				return
			}
			if (!benefitForm.icon) {
				this.setState({ benefitError: 'Veuillez sélectionner une icône.' })
				return
			}
		}
		const creneauxStep = isVente ? 3 : 2
		if (benefitStep === creneauxStep) {
			if (benefitForm.open_hours.length === 0) {
				this.setState({ benefitError: 'Ajoutez au moins un créneau.' })
				return
			}
			if (benefitForm.open_dates.length === 0) {
				this.setState({ benefitError: "Ajoutez au moins une période d'ouverture." })
				return
			}
			const duration = Number(benefitForm.duration_hour) * 60 + Number(benefitForm.duration_minute)
			if (duration > 0) {
				const totalSlots = benefitForm.open_hours.reduce(
					(sum, oh) => sum + this._computeSlotsForRange(oh), 0
				)
				if (totalSlots === 0) {
					this.setState({
						benefitError: "Aucun créneau ne peut être généré : la durée dépasse toutes les plages horaires. Revenez à l'étape précédente pour ajuster la durée, ou élargissez les plages."
					})
					return
				}
			}
		}
		this.setState({ benefitStep: benefitStep + 1, benefitError: null })
	}

	prevBenefitStep = () => {
		this.setState({ benefitStep: this.state.benefitStep - 1, benefitError: null })
	}

	// Saut direct vers une étape (navigation libre en mode édition).
	goToBenefitStep = (n) => {
		this.setState({ benefitStep: n, benefitError: null })
	}

	// Valide l'ensemble du formulaire (toutes étapes confondues) et renvoie
	// { step, error } de la première erreur, ou null si tout est valide.
	// Utilisé avant submitBenefit pour autoriser la sauvegarde depuis n'importe quelle étape.
	validateBenefitForm = () => {
		const { benefitForm, service } = this.state
		const isVente = service && service.type === 'vente'
		const defaultTrans = (benefitForm.translations || []).find(t => t.lang === this.props.lang_default)
		if (!defaultTrans || !defaultTrans.subtitle.trim()) {
			return { step: 1, error: 'Le titre est requis (version ' + this.props.lang_default.toUpperCase() + ').' }
		}
		if (!benefitForm.icon) {
			return { step: 1, error: 'Veuillez sélectionner une icône.' }
		}
		const creneauxStep = isVente ? 3 : 2
		if (benefitForm.open_hours.length === 0) {
			return { step: creneauxStep, error: 'Ajoutez au moins un créneau.' }
		}
		if (benefitForm.open_dates.length === 0) {
			return { step: creneauxStep, error: "Ajoutez au moins une période d'ouverture." }
		}
		const duration = Number(benefitForm.duration_hour) * 60 + Number(benefitForm.duration_minute)
		if (duration > 0) {
			const totalSlots = benefitForm.open_hours.reduce((sum, oh) => sum + this._computeSlotsForRange(oh), 0)
			if (totalSlots === 0) {
				return { step: creneauxStep, error: "Aucun créneau ne peut être généré : la durée dépasse toutes les plages horaires. Revenez à l'étape Créneaux pour ajuster la durée, ou élargissez les plages." }
			}
		}
		return null
	}

	_computeSlotsForRange = (oh) => {
		const { benefitForm } = this.state
		const duration = Number(benefitForm.duration_hour) * 60 + Number(benefitForm.duration_minute)
		const interval = Number(benefitForm.interval_hour) * 60 + Number(benefitForm.interval_minute)
		if (duration === 0) return 0
		let start = oh.start_hour * 60 + oh.start_minute
		let end_slot = start + duration
		const deadline = oh.end_hour * 60 + oh.end_minute
		let count = 0
		while (end_slot + interval <= deadline) {
			count++
			start = end_slot + interval
			end_slot = start + duration
		}
		return count
	}


	_handleWorkerAssignments = (benefitId) => {
		const { benefitForm, workers, service } = this.state
		if (!service || service.type !== 'prestation') return Promise.resolve()
		const selectedIds = benefitForm.selectedWorkerIds || []
		const allWorkers = workers || []
		const promises = []

		if (selectedIds.length === 0) {
			// Si aucun worker avec services:[] n'existe, en créer un par défaut
			const hasDefault = allWorkers.some(w => w.services.length === 0)
			if (!hasDefault) {
				const defaultWorker = {
					service: service._id,
					firstname: 'Équipe',
					lastname: service.name,
					working_dates: [{ start_day: 1, start_month: 1, end_day: 31, end_month: 12 }],
					working_hours: [{
						monday: true, tuesday: true, wednesday: true, thursday: true,
						friday: true, saturday: true, sunday: true,
						start_hour: 0, start_minute: 0, end_hour: 23, end_minute: 59
					}],
					services: [],
					user: this.props.user._id
				}
				promises.push(
					this.props.insertServiceWorker(defaultWorker).then(w => {
						this.setState({ workers: [...(this.state.workers || []), w] })
					})
				)
			}
			// Retirer benefitId de tout worker qui l'avait explicitement
			allWorkers.forEach(w => {
				if (w.services.indexOf(benefitId) !== -1) {
					const updated = { ...w, services: w.services.filter(s => s !== benefitId) }
					promises.push(this.props.updateServiceWorker(updated).then(ret => {
						if (ret && ret._id) {
							const updatedWorkers = (this.state.workers || []).map(x => x._id === ret._id ? ret : x)
							this.setState({ workers: updatedWorkers })
						}
					}))
				}
			})
		} else {
			allWorkers.forEach(w => {
				const isSelected = selectedIds.indexOf(w._id) !== -1
				const hasBenefit = w.services.indexOf(benefitId) !== -1
				if (isSelected && !hasBenefit) {
					const updated = { ...w, services: [...w.services, benefitId] }
					promises.push(this.props.updateServiceWorker(updated).then(ret => {
						if (ret && ret._id) {
							const updatedWorkers = (this.state.workers || []).map(x => x._id === ret._id ? ret : x)
							this.setState({ workers: updatedWorkers })
						}
					}))
				} else if (!isSelected && hasBenefit) {
					const updated = { ...w, services: w.services.filter(s => s !== benefitId) }
					promises.push(this.props.updateServiceWorker(updated).then(ret => {
						if (ret && ret._id) {
							const updatedWorkers = (this.state.workers || []).map(x => x._id === ret._id ? ret : x)
							this.setState({ workers: updatedWorkers })
						}
					}))
				}
			})
		}
		return Promise.all(promises)
	}

	submitBenefit = () => {
		const { benefitForm, service, editingBenefitId, showVenteSubSlots } = this.state
		const isVente = service && service.type === 'vente'
		// La sauvegarde est possible depuis n'importe quelle étape : on valide tout d'abord,
		// et on renvoie l'utilisateur sur l'étape fautive en cas d'erreur.
		const validation = this.validateBenefitForm()
		if (validation) {
			this.setState({ benefitStep: validation.step, benefitError: validation.error })
			return
		}
		this.setState({ benefitLoading: true, benefitError: null })

		const max = benefitForm.participants_unlimited ? null : Number(benefitForm.max_participants)
		// On émet une entrée pour chaque langue : le sous-titre (obligatoire) retombe
		// sur la langue par défaut s'il n'a pas été traduit, pour ne jamais afficher de titre vide.
		const typedTranslations = benefitForm.translations || []
		const defaultTranslation = typedTranslations.find(t => t.lang === this.props.lang_default) || {}
		const translations = (this.props.langs || []).map(lang => {
			const t = typedTranslations.find(x => x.lang === lang) || {}
			const subtitle = (t.subtitle || '').trim() || (defaultTranslation.subtitle || '').trim()
			return {
				lang: lang,
				subtitle: subtitle,
				location: (t.location || '').trim(),
				description: (t.description || '').trim()
			}
		})
		const benefit = {
			service: service._id,
			translations: translations,
			duration_hour: (isVente && !showVenteSubSlots) ? 0 : Number(benefitForm.duration_hour),
			duration_minute: (isVente && !showVenteSubSlots) ? 0 : Number(benefitForm.duration_minute),
			interval_hour: (isVente && showVenteSubSlots) ? Number(benefitForm.interval_hour) : 0,
			interval_minute: (isVente && showVenteSubSlots) ? Number(benefitForm.interval_minute) : 0,
			limit_end: Number(benefitForm.limit_end_h) + Number(benefitForm.limit_end_m) / 60,
			cancel_limit: Number(benefitForm.cancel_limit_h) + Number(benefitForm.cancel_limit_m) / 60,
			open_dates: benefitForm.open_dates,
			open_hours: benefitForm.open_hours,
			simultaneous: max,
			options: { limit: !benefitForm.participants_unlimited, simultaneous: max },
			price: benefitForm.price === '' ? 0 : Number(benefitForm.price),
			show_price: benefitForm.price !== '' && Number(benefitForm.price) > 0,
			icon: benefitForm.icon,
			confirmation: false,
			client_number: benefitForm.client_number,
			identity: benefitForm.identity,
			age: benefitForm.age,
			phone: benefitForm.phone,
			questions: benefitForm.questions,
			user: this.props.user._id
		}

		if (editingBenefitId) {
			benefit._id = editingBenefitId
			this.props.updateServiceBenefit(benefit)
				.then(() => this._handleWorkerAssignments(editingBenefitId))
				.then(() => {
					const existing = this.state.benefits.find(b => b._id === editingBenefitId) || {}
					const updatedBenefit = { ...existing, ...benefit }
					const benefits = this.state.benefits.map(b => b._id === editingBenefitId ? updatedBenefit : b)
					this.setState({ benefits, showBenefitWizard: false, editingBenefitId: null, benefitLoading: false })
				})
				.catch(() => {
					this.setState({ benefitLoading: false, benefitError: "Une erreur s'est produite. Veuillez réessayer." })
				})
		} else {
			this.props.insertServiceBenefit(benefit)
				.then(newBenefit => this._handleWorkerAssignments(newBenefit._id).then(() => newBenefit))
				.then(newBenefit => {
					this.setState({
						benefits: [...this.state.benefits, newBenefit],
						showBenefitWizard: false,
						benefitLoading: false
					})
				})
				.catch(() => {
					this.setState({ benefitLoading: false, benefitError: "Une erreur s'est produite. Veuillez réessayer." })
				})
		}
	}

	deleteBenefit = (id) => {
		this.props.deleteServiceBenefit(id)
			.then(ret => {
				if (ret === true)
					this.setState({ benefits: this.state.benefits.filter(b => b._id !== id), deleteConfirm: null })
			})
			.catch(() => {})
	}

	// ─── Workers ─────────────────────────────────────────────────────────────────

	openWorkerForm = () => {
		this.setState({ showWorkerForm: true, workerForm: { firstname: '', lastname: '' }, workerError: null })
	}

	closeWorkerForm = () => {
		this.setState({ showWorkerForm: false })
	}

	submitWorker = () => {
		const { workerForm, service } = this.state
		if (!workerForm.firstname.trim() && !workerForm.lastname.trim()) {
			this.setState({ workerError: 'Renseignez au moins un nom ou prénom.' })
			return
		}
		this.setState({ workerLoading: true })

		const worker = {
			service: service._id,
			firstname: workerForm.firstname.trim(),
			lastname: workerForm.lastname.trim(),
			working_dates: [{ start_day: 1, start_month: 1, end_day: 31, end_month: 12 }],
			working_hours: [{
				monday: true, tuesday: true, wednesday: true, thursday: true,
				friday: true, saturday: true, sunday: true,
				start_hour: 0, start_minute: 0, end_hour: 23, end_minute: 59
			}],
			services: [],
			user: this.props.user._id
		}

		this.props.insertServiceWorker(worker)
			.then(newWorker => {
				this.setState({
					workers: [...(this.state.workers || []), newWorker],
					showWorkerForm: false,
					workerLoading: false
				})
			})
			.catch(() => {
				this.setState({ workerLoading: false, workerError: "Erreur lors de la création." })
			})
	}

	deleteWorker = (id) => {
		this.props.deleteServiceWorker(id)
			.then(ret => {
				if (ret === true)
					this.setState({ workers: this.state.workers.filter(w => w._id !== id) })
			})
			.catch(() => {})
	}

	openEditWorker = (worker) => {
		this.setState({
			editingWorkerId: worker._id,
			workerEditForm: {
				firstname: worker.firstname || '',
				lastname: worker.lastname || '',
				working_dates: worker.working_dates.map(d => ({ ...d })),
				working_hours: worker.working_hours.map(h => ({ ...h })),
				services: (worker.services || []).slice()
			},
			workerEditError: null,
			showWorkerForm: false
		})
	}

	closeEditWorker = () => {
		this.setState({ editingWorkerId: null, workerEditForm: null, workerEditError: null })
	}

	setWorkerEditField = (key, val) => {
		this.setState({ workerEditForm: { ...this.state.workerEditForm, [key]: val } })
	}

	setWorkerDate = (i, key, val) => {
		const dates = this.state.workerEditForm.working_dates.map((d, idx) => idx === i ? { ...d, [key]: val } : d)
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_dates: dates } })
	}

	addWorkerDate = () => {
		const dates = [...this.state.workerEditForm.working_dates, { start_day: 1, start_month: 1, end_day: 31, end_month: 12 }]
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_dates: dates } })
	}

	removeWorkerDate = (i) => {
		if (this.state.workerEditForm.working_dates.length <= 1) return
		const dates = this.state.workerEditForm.working_dates.filter((_, idx) => idx !== i)
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_dates: dates } })
	}

	setWorkerHour = (i, key, val) => {
		const hours = this.state.workerEditForm.working_hours.map((h, idx) => idx === i ? { ...h, [key]: val } : h)
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_hours: hours } })
	}

	toggleWorkerDay = (i, day) => {
		const hours = this.state.workerEditForm.working_hours.map((h, idx) => idx === i ? { ...h, [day]: !h[day] } : h)
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_hours: hours } })
	}

	addWorkerHour = () => {
		const hours = [...this.state.workerEditForm.working_hours, {
			monday: false, tuesday: false, wednesday: false, thursday: false,
			friday: false, saturday: false, sunday: false,
			start_hour: 9, start_minute: 0, end_hour: 17, end_minute: 0
		}]
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_hours: hours } })
	}

	removeWorkerHour = (i) => {
		if (this.state.workerEditForm.working_hours.length <= 1) return
		const hours = this.state.workerEditForm.working_hours.filter((_, idx) => idx !== i)
		this.setState({ workerEditForm: { ...this.state.workerEditForm, working_hours: hours } })
	}

	toggleWorkerService = (id) => {
		const services = this.state.workerEditForm.services.slice()
		const idx = services.indexOf(id)
		if (idx !== -1) services.splice(idx, 1)
		else services.push(id)
		this.setState({ workerEditForm: { ...this.state.workerEditForm, services: services } })
	}

	submitEditWorker = () => {
		const { workerEditForm, editingWorkerId, service } = this.state
		if (!workerEditForm.firstname.trim() && !workerEditForm.lastname.trim()) {
			this.setState({ workerEditError: 'Renseignez au moins un nom ou prénom.' })
			return
		}
		this.setState({ workerEditLoading: true })
		const worker = {
			_id: editingWorkerId,
			service: service._id,
			firstname: workerEditForm.firstname.trim(),
			lastname: workerEditForm.lastname.trim(),
			working_dates: workerEditForm.working_dates,
			working_hours: workerEditForm.working_hours,
			services: workerEditForm.services,
			user: this.props.user._id
		}
		this.props.updateServiceWorker(worker)
			.then(updated => {
				const updatedWorkers = this.state.workers.map(w => w._id === updated._id ? updated : w)
				this.setState({ workers: updatedWorkers, editingWorkerId: null, workerEditForm: null, workerEditLoading: false })
			})
			.catch(() => {
				this.setState({ workerEditLoading: false, workerEditError: 'Erreur lors de la sauvegarde.' })
			})
	}

	// ─── Helpers ─────────────────────────────────────────────────────────────────

	formatCreneau = (c) => {
		const days = DAYS.filter(d => c[d.key]).map(d => d.label).join(' ')
		const start = `${String(c.start_hour).padStart(2, '0')}h${String(c.start_minute).padStart(2, '0')}`
		const end = `${String(c.end_hour).padStart(2, '0')}h${String(c.end_minute).padStart(2, '0')}`
		return `${days} · ${start} → ${end}`
	}

	formatDateRange = (d) => {
		const sm = MONTHS[d.start_month - 1]
		const em = MONTHS[d.end_month - 1]
		return `${String(d.start_day).padStart(2, '0')} ${sm} → ${String(d.end_day).padStart(2, '0')} ${em}`
	}

	getTitle = (translations) => {
		if (!translations) return ''
		const lang = this.state.current_lang
		const byLang = translations.find(t => t.lang === lang && t.subtitle)
		if (byLang) return byLang.subtitle
		const byDefault = translations.find(t => t.lang === this.props.lang_default && t.subtitle)
		if (byDefault) return byDefault.subtitle
		return (translations[0] && translations[0].subtitle) || ''
	}

	getProductTitle = (translations) => {
		if (!translations) return ''
		const lang = this.state.current_lang
		const byLang = translations.find(t => t.lang === lang && t.title)
		if (byLang) return byLang.title
		const byDefault = translations.find(t => t.lang === this.props.lang_default && t.title)
		if (byDefault) return byDefault.title
		return (translations[0] && translations[0].title) || ''
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	setBenefitTranslation = (field, value) => {
		const lang = this.state.current_lang
		const translations = [...this.state.benefitForm.translations]
		const idx = translations.findIndex(t => t.lang === lang)
		if (idx >= 0)
			translations[idx] = { ...translations[idx], [field]: value }
		else
			translations.push({ lang, subtitle: '', location: '', description: '', [field]: value })
		this.setState({ benefitForm: { ...this.state.benefitForm, translations }, benefitError: null })
	}

	setProductTranslation = (field, value) => {
		const lang = this.state.current_lang
		const translations = [...this.state.productForm.translations]
		const idx = translations.findIndex(t => t.lang === lang)
		if (idx >= 0)
			translations[idx] = { ...translations[idx], [field]: value }
		else
			translations.push({ lang, title: '', description: '', [field]: value })
		this.setState({ productForm: { ...this.state.productForm, translations }, productError: null })
	}

	setQuestionTranslation = (field, value) => {
		const lang = this.state.current_lang
		const translations = [...this.state.questionForm.translations]
		const idx = translations.findIndex(t => t.lang === lang)
		if (idx >= 0)
			translations[idx] = { ...translations[idx], [field]: value }
		else
			translations.push({ lang, title: '', [field]: value })
		this.setState({ questionForm: { ...this.state.questionForm, translations } })
	}

	// ─── Render steps ─────────────────────────────────────────────────────────────

	addQuestion = () => {
		const { questionForm, benefitForm, editingQuestionIndex } = this.state
		const defaultTrans = (questionForm.translations || []).find(t => t.lang === this.props.lang_default)
		if (!defaultTrans || !defaultTrans.title.trim()) {
			this.setState({ benefitError: 'Le texte de la question est requis (version ' + this.props.lang_default.toUpperCase() + ').' })
			return
		}
		if (!questionForm.type) {
			this.setState({ benefitError: 'Le type de réponse est requis.' })
			return
		}
		const question = {
			type: questionForm.type,
			mandatory: questionForm.mandatory,
			translations: (questionForm.translations || []).map(t => ({ lang: t.lang, title: t.title.trim() }))
		}
		let questions
		if (editingQuestionIndex !== null) {
			questions = [...benefitForm.questions]
			questions[editingQuestionIndex] = question
		} else {
			if (benefitForm.questions.length >= 5) {
				this.setState({ benefitError: 'Maximum 5 questions.' })
				return
			}
			questions = [...benefitForm.questions, question]
		}
		this.setState({
			benefitForm: { ...benefitForm, questions },
			questionForm: { translations: [], type: '', mandatory: false },
			showQuestionForm: false,
			editingQuestionIndex: null,
			benefitError: null
		})
	}

	removeQuestion = (index) => {
		const questions = [...this.state.benefitForm.questions]
		questions.splice(index, 1)
		this.setState({ benefitForm: { ...this.state.benefitForm, questions } })
	}

	editQuestion = (index) => {
		const q = this.state.benefitForm.questions[index]
		this.setState({
			showQuestionForm: true,
			editingQuestionIndex: index,
			questionForm: { translations: (q.translations || []).map(t => ({ ...t })), type: q.type, mandatory: q.mandatory },
			benefitError: null
		})
	}

	
	// ─── Products (vente) ────────────────────────────────────────────────────────

	loadProducts = () => {
		const { service } = this.state
		if (!service || service.type !== 'vente' || !this.props.fetchServiceProductsByService) return
		this.props.fetchServiceProductsByService(service._id)
			.then(products => {
				const sorted = (products || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0))
				this.setState({ products: sorted })
			})
			.catch(() => {})
	}

	openEditProductForm = (product) => {
		this.setState({
			showProductForm: true,
			editingProductId: product._id,
			productForm: {
				translations: (product.translations || []).map(t => ({ ...t })),
				price: product.price != null ? String(product.price) : '',
				stock: product.stock != null ? String(product.stock) : '',
				image: product.image || null,
				family: product.family || null
			},
			productError: null
		})
	}

	handleProductImage = (e) => {
		const file = e.target.files[0]
		if (!file) return
		this.setState({ productImageUploading: true })
		const fd = new FormData()
		fd.append('file', file)
		fd.append('path', 'images/')
		fetch(connexion.connect.url + 'dashboard/files/add-image', { method: 'POST', body: fd })
			.then(r => r.json())
			.then(ret => {
				if (ret && ret._id)
					this.setState({ productForm: { ...this.state.productForm, image: String(ret._id) }, productImageUploading: false })
				else
					this.setState({ productImageUploading: false })
			})
			.catch(() => this.setState({ productImageUploading: false }))
	}

	saveProduct = (closeForm) => {
		const { productForm, service, products, editingProductId } = this.state
		const defaultTrans = (productForm.translations || []).find(t => t.lang === this.props.lang_default)
		if (!defaultTrans || !defaultTrans.title.trim()) {
			this.setState({ productError: 'Le nom est requis (version ' + this.props.lang_default.toUpperCase() + ').' })
			return
		}
		if (productForm.price === '' || isNaN(Number(productForm.price))) {
			this.setState({ productError: 'Le prix est requis.' })
			return
		}
		this.setState({ productLoading: true, productError: null })
		const payload = {
			service: service._id,
			icon: null,
			image: productForm.image || null,
			family: productForm.family || null,
			price: Number(productForm.price),
			stock: productForm.stock !== '' ? Number(productForm.stock) : null,
			translations: (productForm.translations || []).map(t => ({
				lang: t.lang,
				title: (t.title || '').trim(),
				description: (t.description || '').trim()
			})),
			user: this.props.user._id
		}
		if (editingProductId) {
			payload._id = editingProductId
			this.props.updateServiceProduct(payload)
				.then(updated => {
					const existing = products.find(p => p._id === editingProductId) || {}
					this.setState({
						products: products.map(p => p._id === editingProductId ? { ...existing, ...updated } : p),
						productLoading: false,
						productForm: { translations: [], price: '', stock: '', image: null },
						showProductForm: false,
						editingProductId: null
					})
				})
				.catch(() => this.setState({ productLoading: false, productError: "Une erreur s'est produite." }))
		} else {
			this.props.insertServiceProduct(payload)
				.then(newProduct => {
					this.setState({
						products: [...products, newProduct],
						productLoading: false,
						productForm: { translations: [], price: '', stock: '', image: null },
						showProductForm: !closeForm
					})
				})
				.catch(() => this.setState({ productLoading: false, productError: "Une erreur s'est produite." }))
		}
	}

	deleteProduct = (id) => {
		this.props.deleteServiceProduct(id)
			.then(ret => {
				if (ret === true)
					this.setState({ products: this.state.products.filter(p => p._id !== id), deleteProductConfirm: null })
			})
			.catch(() => {})
	}

	// ─── Families ────────────────────────────────────────────────────────────────

	getFamilyDisplayName = (family) => {
		const lang = this.state.current_lang || this.props.lang_default
		const t = (family.translations || []).find(t => t.lang === lang)
		if (t && t.name) return t.name
		return ((family.translations || [])[0] || {}).name || ''
	}

	saveFamilies = (newFamilies) => {
		const { service } = this.state
		this.setState({ familySaving: true })
		const updated = { ...service, families: newFamilies, user: this.props.user._id }
		this.props.updateService(updated)
			.then(ret => { if (ret) this.setState({ service: ret, familySaving: false }) })
			.catch(() => this.setState({ familySaving: false }))
	}

	addFamily = () => {
		const { familyAddInput, service } = this.state
		const name = familyAddInput.trim()
		if (!name) { this.setState({ familyAddInput: '', familyAddShow: false }); return }
		const lang = this.props.lang_default
		const families = service.families || []
		const dup = families.some(f => {
			const t = (f.translations || []).find(t => t.lang === lang)
			return t && t.name.trim().toLowerCase() === name.toLowerCase()
		})
		if (dup) { this.setState({ familyAddError: 'Cette famille existe déjà.' }); return }
		if (families.length >= MAX_FAMILIES) return
		const newFamily = makeFamily(name, families.length, lang)
		const updated = [...families, newFamily]
		this.setState({ familyAddInput: '', familyAddShow: false, familyAddError: null })
		this.saveFamilies(updated)
	}

	startEditFamily = (family) => {
		this.setState({ familyEditId: family.id, familyEditValue: this.getFamilyDisplayName(family), familyEditError: null })
	}

	saveEditFamily = (id) => {
		const { familyEditValue, service } = this.state
		const name = familyEditValue.trim()
		if (!name) { this.setState({ familyEditId: null }); return }
		const lang = this.props.lang_default
		const families = service.families || []
		const dup = families.some(f => f.id !== id && (() => {
			const t = (f.translations || []).find(t => t.lang === lang)
			return t && t.name.trim().toLowerCase() === name.toLowerCase()
		})())
		if (dup) { this.setState({ familyEditError: 'Cette famille existe déjà.' }); return }
		const updated = families.map(f => {
			if (f.id !== id) return f
			const translations = (f.translations || []).map(t => t.lang === lang ? { ...t, name } : t)
			if (!translations.find(t => t.lang === lang)) translations.push({ lang, name })
			return { ...f, translations }
		})
		this.setState({ familyEditId: null, familyEditValue: '', familyEditError: null })
		this.saveFamilies(updated)
	}

	deleteFamily = (id) => {
		const { service, products } = this.state
		const families = (service.families || []).filter(f => f.id !== id).map((f, i) => ({ ...f, order: i }))
		this.saveFamilies(families)
		const updatedProducts = products.map(p => p.family === id ? { ...p, family: null } : p)
		this.setState({ products: updatedProducts, familyDeleteConfirm: null })
	}

	onFamilyDragStart = (id) => { this.setState({ familyDragSourceId: id, familyDragOverId: null }) }
	onFamilyDragEnter = (id) => { if (id !== this.state.familyDragSourceId) this.setState({ familyDragOverId: id }) }
	onFamilyDrop = (targetId) => {
		const { service, familyDragSourceId } = this.state
		const families = service.families || []
		if (!familyDragSourceId || familyDragSourceId === targetId) { this.setState({ familyDragSourceId: null, familyDragOverId: null }); return }
		const from = families.findIndex(f => f.id === familyDragSourceId)
		const to = families.findIndex(f => f.id === targetId)
		if (from === -1 || to === -1) { this.setState({ familyDragSourceId: null, familyDragOverId: null }); return }
		const reordered = families.slice()
		const [moved] = reordered.splice(from, 1)
		reordered.splice(to, 0, moved)
		const withOrder = reordered.map((f, i) => ({ ...f, order: i }))
		this.setState({ familyDragSourceId: null, familyDragOverId: null })
		this.saveFamilies(withOrder)
	}

	// ─── Products DnD ─────────────────────────────────────────────────────────────

	onDragStart = (id) => {
		this.setState({ dragSourceId: id, dragOverId: null })
	}

	onDragEnter = (id) => {
		if (id !== this.state.dragSourceId)
			this.setState({ dragOverId: id })
	}

	onDrop = (targetId) => {
		const { products, dragSourceId } = this.state
		if (!dragSourceId || dragSourceId === targetId)
		{
			this.setState({ dragSourceId: null, dragOverId: null })
			return
		}
		const from = products.findIndex(p => p._id === dragSourceId)
		const to = products.findIndex(p => p._id === targetId)
		if (from === -1 || to === -1)
		{
			this.setState({ dragSourceId: null, dragOverId: null })
			return
		}
		const reordered = products.slice()
		const [moved] = reordered.splice(from, 1)
		reordered.splice(to, 0, moved)
		this.setState({ products: reordered, dragSourceId: null, dragOverId: null })
		this.props.reorderServiceProducts(reordered.map(p => p._id))
	}

	renderProductForm = (isInline) => {
		const { productForm, productLoading, productError, editingProductId, service } = this.state
		const ptLang = this.state.current_lang
		const pt = (productForm.translations || []).find(x => x.lang === ptLang) || { title: '', description: '' }
		const cancelForm = () => this.setState({ showProductForm: false, productForm: { translations: [], price: '', stock: '', image: null, family: null }, productError: null, editingProductId: null })
		return (
			<div className={`rounded-xl border border-indigo-200 bg-indigo-50 p-4${isInline ? '' : ' mb-4'}`}>
				<p className="text-base font-semibold text-gray-700 mb-3">{editingProductId ? 'Modifier le produit' : 'Nouveau produit'}</p>
				<LangSelector lang={this.state.current_lang} updateLang={this.updateLang} />
				<div className="mb-3">
					<label className="block text-base font-medium text-gray-700 mb-1">Nom <span className="text-red-400">*</span></label>
					<input type="text" value={pt.title}
						onChange={e => this.setProductTranslation('title', e.target.value.slice(0, 80))}
						placeholder="ex : Croissant beurre"
						className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
					/>
				</div>
				<div className="mb-3">
					<label className="block text-base font-medium text-gray-700 mb-1">Description <span className="text-gray-400 font-normal" style={{ fontSize: '0.8em' }}>optionnelle</span></label>
					<textarea
						value={pt.description}
						onChange={e => this.setProductTranslation('description', e.target.value.slice(0, 200))}
						placeholder="ex : Base tomate, mozzarella, jambon"
						rows={2}
						style={{ resize: 'none' }}
						className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
					/>
				</div>
				{service && (service.families || []).length > 0 && (
					<div className="mb-3">
						<label className="block text-base font-medium text-gray-700 mb-1">Famille <span className="text-gray-400 font-normal" style={{ fontSize: '0.8em' }}>optionnelle</span></label>
						<div style={{ display: 'flex', gap: '8px', overflowX: 'auto', WebkitOverflowScrolling: 'touch', paddingBottom: '4px' }}>
							{(service.families || []).map(f => {
								const selected = productForm.family === f.id
								return (
									<button key={f.id} type="button"
										onClick={() => this.setState({ productForm: { ...productForm, family: selected ? null : f.id } })}
										style={{ backgroundImage: 'none', backgroundColor: selected ? '#f3f4f6' : 'white', border: `1px solid ${selected ? '#d1d5db' : '#e5e7eb'}`, borderRadius: '9999px', padding: '5px 14px', fontSize: '0.9rem', fontWeight: selected ? 600 : 400, color: selected ? '#111827' : '#374151', flexShrink: 0, transition: 'all 0.15s', cursor: 'pointer' }}>
										{this.getFamilyDisplayName(f)}
									</button>
								)
							})}
						</div>
					</div>
				)}
				<div className="flex gap-3 mb-3">
					<div>
						<label className="block text-base font-medium text-gray-700 mb-1">Prix <span className="text-red-400">*</span></label>
						<div className="flex items-center gap-1.5">
							<input type="number" min="0" step="0.01" value={productForm.price}
								onChange={e => this.setState({ productForm: { ...productForm, price: e.target.value } })}
								placeholder="0"
								className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
								style={{ width: '5.5rem' }}
							/>
							<span className="text-base text-gray-500">€</span>
						</div>
					</div>
					<div>
						<label className="block text-base font-medium text-gray-700 mb-1">Stock <span className="text-gray-400 font-normal">(optionnel)</span></label>
						<input type="number" min="0" value={productForm.stock}
							onChange={e => this.setState({ productForm: { ...productForm, stock: e.target.value } })}
							placeholder="∞"
							className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
							style={{ width: '5.5rem' }}
						/>
					</div>
				</div>
				{service && service.product_images && (
					<div className="mb-3">
						<label className="block text-base font-medium text-gray-700 mb-1">Photo <span className="text-gray-400 font-normal">(optionnelle)</span></label>
						<input ref={this.productImageRef} type="file" accept="image/jpeg,image/png,image/gif" className="hidden" onChange={this.handleProductImage} />
						{productForm.image ? (
							<div className="flex items-center gap-3">
								<img src={connexion.connect.url + 'dashboard/files/get-image/' + productForm.image + '/200'} alt="" style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }} />
								<div className="flex flex-col gap-1">
									<button type="button" onClick={() => this.productImageRef.current && this.productImageRef.current.click()} style={{ backgroundImage: 'none', backgroundColor: 'transparent' }} className="text-base text-indigo-600 hover:text-indigo-800 text-left">Changer</button>
									<button type="button" onClick={() => this.setState({ productForm: { ...productForm, image: null } })} style={{ backgroundImage: 'none', backgroundColor: 'transparent' }} className="text-base text-red-500 hover:text-red-700 text-left">Supprimer</button>
								</div>
							</div>
						) : (
							<button type="button" onClick={() => this.productImageRef.current && this.productImageRef.current.click()} disabled={this.state.productImageUploading} style={{ backgroundImage: 'none', backgroundColor: 'white' }} className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-gray-300 text-base text-gray-600 hover:border-indigo-400 hover:text-indigo-600 disabled:opacity-50">
								{this.state.productImageUploading ? 'Envoi...' : '+ Ajouter une photo'}
							</button>
						)}
					</div>
				)}
				{productError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-2.5 mb-3 text-base text-red-700">{productError}</div>
				)}
				<div className="flex gap-2">
					<button type="button" onClick={cancelForm}
						className="py-2 px-3 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-white transition-colors">
						Annuler
					</button>
					{!editingProductId && (
						<button type="button" onClick={() => this.saveProduct(false)} disabled={productLoading}
							className="py-2 px-3 rounded-xl border border-indigo-200 text-indigo-700 text-base font-medium hover:bg-white transition-colors disabled:opacity-50">
							+ Ajouter un autre
						</button>
					)}
					<button type="button" onClick={() => this.saveProduct(true)} disabled={productLoading}
						className="flex-1 py-2 rounded-xl bg-indigo-600 text-white text-base font-medium hover:bg-indigo-700 disabled:opacity-50">
						{productLoading ? '...' : (editingProductId ? 'Enregistrer' : 'Ajouter')}
					</button>
				</div>
			</div>
		)
	}

	renderFamiliesBlock = () => {
		const { service, familyEditId, familyEditValue, familyEditError, familyDeleteConfirm, familyAddInput, familyAddError, familyAddShow, familyDragSourceId, familyDragOverId, products } = this.state
		const families = service.families || []
		return (
			<div className="mb-5">
				<div className="flex items-center justify-between mb-2">
					<span className="text-base font-semibold text-gray-400 uppercase tracking-wider">Familles <span className="text-gray-300 font-normal normal-case">{families.length}/{MAX_FAMILIES}</span></span>
					{families.length < MAX_FAMILIES && !familyAddShow && (
						<button type="button" onClick={() => this.setState({ familyAddShow: true, familyAddInput: '', familyAddError: null })}
							style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
							className="text-base text-indigo-600 font-medium">+ Ajouter</button>
					)}
				</div>
				{families.length > 0 && (
					<div className="flex flex-col">
						{families.map(f => {
							const isDragging = familyDragSourceId === f.id
							const isOver = familyDragOverId === f.id
							const affectedCount = products.filter(p => p.family === f.id).length
							return (
								<React.Fragment key={f.id}>
									{isOver && <div style={{ height: '2px', background: '#6366f1', borderRadius: '1px', margin: '0 4px', flexShrink: 0 }} />}
									<div
										draggable
										onDragStart={() => this.onFamilyDragStart(f.id)}
										onDragEnter={() => this.onFamilyDragEnter(f.id)}
										onDragOver={e => e.preventDefault()}
										onDrop={() => this.onFamilyDrop(f.id)}
										onDragEnd={() => this.setState({ familyDragSourceId: null, familyDragOverId: null })}
										className="flex items-center justify-between rounded-xl border bg-white px-3 py-2.5 mb-2"
										style={{ borderColor: '#e5e7eb', opacity: isDragging ? 0.4 : 1, cursor: 'grab' }}
									>
										{familyEditId === f.id ? (
											<div className="flex items-center gap-2 flex-1">
												<div style={{ position: 'relative', flex: 1 }}>
													<input autoFocus type="text" value={familyEditValue}
														onChange={e => this.setState({ familyEditValue: e.target.value.slice(0, MAX_FAMILY_NAME), familyEditError: null })}
														onKeyDown={e => { if (e.key === 'Enter') this.saveEditFamily(f.id); if (e.key === 'Escape') this.setState({ familyEditId: null }) }}
														className="w-full border border-indigo-400 rounded-lg px-3 py-1.5 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
													/>
													<span style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.72rem', color: '#9ca3af' }}>{familyEditValue.length}/{MAX_FAMILY_NAME}</span>
												</div>
												<button type="button" onClick={() => this.saveEditFamily(f.id)} style={{ backgroundImage: 'none', backgroundColor: '#4f46e5', color: 'white', borderRadius: '8px', padding: '5px 10px', fontSize: '0.85rem', fontWeight: 600 }}>OK</button>
												<button type="button" onClick={() => this.setState({ familyEditId: null })} style={{ backgroundImage: 'none', backgroundColor: 'transparent', color: '#9ca3af', fontSize: '1.1rem' }}>×</button>
												{familyEditError && <span style={{ color: '#ef4444', fontSize: '0.82rem' }}>{familyEditError}</span>}
											</div>
										) : (
											<>
												<div className="flex items-center gap-2 min-w-0">
													<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" /></svg>
													<span className="text-base font-medium text-gray-800 truncate">{this.getFamilyDisplayName(f)}</span>
													{affectedCount > 0 && <span className="text-sm text-gray-400">{affectedCount} article{affectedCount > 1 ? 's' : ''}</span>}
												</div>
												{familyDeleteConfirm === f.id ? (
													<div className="flex items-center gap-2 text-base ml-2 flex-shrink-0">
														<span className="text-sm text-gray-500">{affectedCount > 0 ? `${affectedCount} article${affectedCount > 1 ? 's' : ''} → Autres` : 'Supprimer ?'}</span>
														<button type="button" onClick={() => this.deleteFamily(f.id)} className="font-semibold text-red-600 hover:text-red-700">Confirmer</button>
														<button type="button" onClick={() => this.setState({ familyDeleteConfirm: null })} className="text-gray-400 hover:text-gray-600">Annuler</button>
													</div>
												) : (
													<div className="flex items-center gap-1 ml-2 flex-shrink-0">
														<button type="button" onClick={() => this.startEditFamily(f)} className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
															<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
														</button>
														<button type="button" onClick={() => this.setState({ familyDeleteConfirm: f.id })} className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
															<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
														</button>
													</div>
												)}
											</>
										)}
									</div>
								</React.Fragment>
							)
						})}
					</div>
				)}
				{familyAddShow && (
					<div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
						<div style={{ position: 'relative', flex: 1 }}>
							<input autoFocus type="text" value={familyAddInput}
								onChange={e => this.setState({ familyAddInput: e.target.value.slice(0, MAX_FAMILY_NAME), familyAddError: null })}
								onKeyDown={e => { if (e.key === 'Enter') this.addFamily(); if (e.key === 'Escape') this.setState({ familyAddShow: false, familyAddInput: '', familyAddError: null }) }}
								placeholder="Nom de la famille"
								maxLength={MAX_FAMILY_NAME}
								className="w-full border border-indigo-400 rounded-xl px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
							/>
							<span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.72rem', color: '#9ca3af' }}>{familyAddInput.length}/{MAX_FAMILY_NAME}</span>
						</div>
						<button type="button" onClick={this.addFamily} style={{ backgroundImage: 'none', backgroundColor: '#4f46e5', color: 'white', borderRadius: '10px', padding: '8px 14px', fontSize: '0.9rem', fontWeight: 600 }}>OK</button>
						<button type="button" onClick={() => this.setState({ familyAddShow: false, familyAddInput: '', familyAddError: null })} style={{ backgroundImage: 'none', backgroundColor: 'transparent', color: '#9ca3af', fontSize: '1.1rem' }}>×</button>
					</div>
				)}
				{familyAddError && <p style={{ color: '#ef4444', fontSize: '0.85rem', marginBottom: '4px' }}>{familyAddError}</p>}
				{families.length >= MAX_FAMILIES && !familyAddShow && (
					<p className="text-sm text-gray-400">Limite atteinte ({MAX_FAMILIES}/{MAX_FAMILIES})</p>
				)}
			</div>
		)
	}

	renderProductsStep = () => {
		const { products, showProductForm, editingProductId, deleteProductConfirm, dragSourceId, dragOverId } = this.state
		return (
			<div>
				{this.renderFamiliesBlock()}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Produits disponibles</p>
				<p className="text-base text-gray-400 mb-4">Ajoutez les articles que les campeurs pourront commander.</p>

				{products.length > 0 && (
					<div className="flex flex-col mb-4">
						{products.map(p => {
							if (editingProductId === p._id)
								return <React.Fragment key={p._id}><div className="mb-2">{this.renderProductForm(true)}</div></React.Fragment>
							const title = this.getProductTitle(p.translations)
							const isDragging = dragSourceId === p._id
							const isOver = dragOverId === p._id
							return (
								<React.Fragment key={p._id}>
									{isOver && (
										<div style={{ height: '2px', background: '#6366f1', borderRadius: '1px', margin: '0 4px 0 4px', flexShrink: 0 }} />
									)}
									<div
										draggable
										onDragStart={() => this.onDragStart(p._id)}
										onDragEnter={() => this.onDragEnter(p._id)}
										onDragOver={e => e.preventDefault()}
										onDrop={() => this.onDrop(p._id)}
										onDragEnd={() => this.setState({ dragSourceId: null, dragOverId: null })}
										className="flex items-center justify-between rounded-xl border px-4 py-3 transition-colors bg-white mb-2"
										style={{
											borderColor: '#e5e7eb',
											opacity: isDragging ? 0.4 : 1,
											cursor: 'grab'
										}}
									>
									<div className="flex items-center gap-3 min-w-0">
										<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
											<path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" />
										</svg>
										<div className="min-w-0">
											<p className="text-base font-medium text-gray-800">{title}</p>
											<p className="text-base text-gray-400">{p.price} € · {p.stock != null ? `${p.stock} en stock` : 'Stock illimité'}</p>
										</div>
									</div>
									<div className="flex items-center gap-1 ml-3 flex-shrink-0">
										{deleteProductConfirm === p._id ? (
											<div className="flex items-center gap-2 text-base">
												<button type="button" onClick={() => this.deleteProduct(p._id)} className="font-semibold text-red-600 hover:text-red-700">Confirmer</button>
												<button type="button" onClick={() => this.setState({ deleteProductConfirm: null })} className="text-gray-400 hover:text-gray-600">Annuler</button>
											</div>
										) : (
											<>
												<button type="button" onClick={() => this.openEditProductForm(p)}
													className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
													<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
												</button>
												<button type="button" onClick={() => this.setState({ deleteProductConfirm: p._id })}
													className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
													<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
												</button>
											</>
										)}
									</div>
								</div>
								</React.Fragment>
							)
						})}
					</div>
				)}

				{!editingProductId && (showProductForm ? this.renderProductForm(false) : (
					<button type="button" onClick={() => this.setState({ showProductForm: true, editingProductId: null })}
						className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border-2 border-dashed border-gray-300 text-gray-500 hover:border-indigo-400 hover:text-indigo-600 text-base font-medium transition-colors mb-4">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg>
						Ajouter un produit
					</button>
				))}

				{!this.state.editingBenefitId && (<div className="flex gap-3 mt-2">
					<button type="button" onClick={this.prevBenefitStep}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50">
						← Retour
					</button>
					<button type="button" onClick={this.nextBenefitStep}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700">
						Suivant →
					</button>
				</div>)}
			</div>
		)
	}

	renderVenteCapaciteStep = () => {
		const { benefitForm, benefitLoading, benefitError, editingBenefitId } = this.state
		return (
			<div>
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Capacité</p>

				<div className="mb-6">
					<div className="flex items-start justify-between gap-4">
						<div>
							<p className="text-base font-medium text-gray-700">Limiter les commandes par créneau</p>
							<p className="text-base text-gray-400 mt-0.5">Le nombre de commandes acceptées par créneau de retrait sera limité.</p>
						</div>
						<button type="button"
							onClick={() => this.setBenefitField('participants_unlimited', !benefitForm.participants_unlimited)}
							className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-0.5 focus:outline-none ${!benefitForm.participants_unlimited ? 'bg-indigo-600' : 'bg-gray-200'}`}>
							<span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${!benefitForm.participants_unlimited ? 'translate-x-5' : 'translate-x-0'}`} />
						</button>
					</div>
					{!benefitForm.participants_unlimited && (
						<div className="flex items-center gap-2 mt-3">
							<input type="number" min="1" value={benefitForm.max_participants}
								onChange={e => this.setBenefitField('max_participants', e.target.value === '' ? '' : Math.max(1, parseInt(e.target.value) || 1))}
								onBlur={e => { if (benefitForm.max_participants === '') this.setBenefitField('max_participants', 1) }}
								className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
								style={{ width: '5rem' }}
							/>
							<span className="text-base text-gray-500">commandes max par créneau</span>
						</div>
					)}
				</div>

				{benefitError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{benefitError}</div>
				)}

				{!this.state.editingBenefitId && (<div className="flex gap-3">
					<button type="button" onClick={this.prevBenefitStep} disabled={benefitLoading}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50 disabled:opacity-50">
						← Retour
					</button>
					<button type="button" onClick={this.submitBenefit} disabled={benefitLoading}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700 disabled:opacity-70 flex items-center justify-center gap-2">
						{benefitLoading ? (
							<>
								<svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
								</svg>
								Création...
							</>
						) : (editingBenefitId ? 'Enregistrer' : 'Créer le créneau')}
					</button>
				</div>)}
			</div>
		)
	}

	renderBenefitStep1 = () => {
		const { benefitForm, benefitError, icons, theme, showIconPicker, service, current_lang } = this.state
		const isVente = service && service.type === 'vente'
		const t = (benefitForm.translations || []).find(x => x.lang === current_lang) || { subtitle: '', location: '', description: '' }
		return (
			<div>
				{/* Section : Informations */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Informations</p>
				<LangSelector lang={current_lang} updateLang={this.updateLang} />

				<div className="mb-4">
					<label className="block text-base font-medium text-gray-700 mb-1.5">Titre de la prestation</label>
					<input
						type="text"
						value={t.subtitle}
						onChange={e => this.setBenefitTranslation('subtitle', e.target.value.slice(0, 50))}
						placeholder="ex : Massage relaxant 1h"
						className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
					/>
				</div>

				<div className="mb-4">
					<label className="block text-base font-medium text-gray-700 mb-2">Icône</label>
					{(!icons || !theme) ? (
						<p className="text-base text-gray-400">Chargement des icônes...</p>
					) : benefitForm.icon ? (() => {
						const selectedIc = icons.find(ic => ic._id === benefitForm.icon)
						let previewSrc = null
						if (selectedIc && selectedIc.fill) {
							for (let i = 0; i < selectedIc.fill.length; i++) {
								if (selectedIc.fill[i].theme === theme._id) { previewSrc = selectedIc.fill[i].icon; break }
							}
							if (!previewSrc && selectedIc.fill.length > 0) previewSrc = selectedIc.fill[0].icon
						}
						return (
							<div className="flex items-center gap-3">
								<button type="button" onClick={() => this.setState({ showIconPicker: true })}
									className="w-16 h-16 rounded-xl border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 hover:border-indigo-400 hover:bg-indigo-50 transition-colors">
									{previewSrc && <img src={previewSrc} alt={selectedIc.name} className="w-10 h-10 object-contain" />}
								</button>
								<div>
									<p className="text-base font-medium text-gray-800">{selectedIc && selectedIc.name}</p>
									<button type="button"
										onClick={() => this.setState({ showIconPicker: true })}
										className="text-base text-indigo-500 hover:text-indigo-700 font-medium mt-1">
										Changer d'icône
									</button>
								</div>
							</div>
						)
					})() : null}
					{(!benefitForm.icon || showIconPicker) && (
						<div ref={this.iconPickerRef} className="border border-gray-200 rounded-xl p-3 bg-gray-50 max-h-48 overflow-y-auto">
							<div className="grid grid-cols-8 gap-1">
								{(icons || []).map(ic => {
									let imgSrc = null
									if (ic.fill) {
										for (let i = 0; i < ic.fill.length; i++) {
											if (ic.fill[i].theme === theme._id) { imgSrc = ic.fill[i].icon; break }
										}
									}
									if (!imgSrc && ic.fill && ic.fill.length > 0) imgSrc = ic.fill[0].icon
									if (!imgSrc) return null
									return (
										<button key={ic._id} type="button"
											onClick={() => { this.setBenefitField('icon', ic._id); this.setState({ showIconPicker: false }) }}
											title={ic.name}
											className={"p-1 rounded-lg transition-colors " + (benefitForm.icon === ic._id ? "bg-indigo-100 ring-2 ring-indigo-500" : "hover:bg-gray-200")}>
											<img src={imgSrc} alt={ic.name} className="w-7 h-7 object-contain" />
										</button>
									)
								})}
							</div>
						</div>
					)}
				</div>

				<div className="mb-4">
					<label className="block text-base font-medium text-gray-700 mb-1.5">
						Lieu <span className="text-gray-400 font-normal">(optionnel)</span>
					</label>
					<input
						type="text"
						value={t.location}
						onChange={e => this.setBenefitTranslation('location', e.target.value.slice(0, 30))}
						placeholder="ex : Salle de détente, Piscine..."
						className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
					/>
				</div>

				<div className="mb-4">
					<label className="block text-base font-medium text-gray-700 mb-1.5">
						Description <span className="text-gray-400 font-normal">(optionnel)</span>
					</label>
					<textarea
						value={t.description}
						onChange={e => this.setBenefitTranslation('description', e.target.value.slice(0, 500))}
						placeholder="Décrivez la prestation en quelques mots..."
						rows={4}
						className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
					/>
					<p className="text-base text-gray-400 mt-1 text-right">{t.description.length}/500</p>
				</div>

				{!isVente && (
					<>
						<hr className="border-gray-100 mb-4" />

						{/* Section : Tarification */}
						<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Tarification</p>

						<div className="mb-5">
							<label className="block text-base font-medium text-gray-700 mb-1.5">
								Prix <span className="text-gray-400 font-normal">(optionnel)</span>
							</label>
							<div className="flex items-center gap-2">
								<input type="number" min="0" step="0.01" value={benefitForm.price}
									onChange={e => this.setBenefitField('price', e.target.value)}
									placeholder="0"
									className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
									style={{ width: '6rem' }}
								/>
								<span className="text-base text-gray-500">€</span>
							</div>
						</div>
					</>
				)}

				{benefitError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{benefitError}</div>
				)}

				{!this.state.editingBenefitId && (<div className="flex gap-3 mt-5">
					<button type="button" onClick={this.closeBenefitWizard}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50">
						Annuler
					</button>
					<button type="button" onClick={this.nextBenefitStep}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-medium hover:bg-indigo-700">
						Suivant →
					</button>
				</div>)}
			</div>
		)
	}

	renderBenefitStep2 = () => {
		const { benefitForm, creneauForm, dateForm, benefitError, editingCreneauIndex, showCreneauForm, editingDateIndex, showDateForm, showVenteDelays, showVenteSubSlots } = this.state
		const isVente = this.state.service && this.state.service.type === 'vente'
		return (
			<div>
				{/* Section : Durée & rythme (prestation only) */}
				{!isVente && (
					<div>
						<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Durée &amp; rythme</p>

						<div className="mb-4">
							<label className="block text-base font-medium text-gray-700 mb-1.5">Durée</label>
							<div className="flex items-center gap-3">
								<div className="flex items-center gap-1.5">
									<input type="number" min="0" max="23" value={benefitForm.duration_hour}
										onChange={e => this.setBenefitField('duration_hour', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
										onBlur={e => { if (benefitForm.duration_hour === '') this.setBenefitField('duration_hour', 0) }}
										className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
										style={{ width: '4.5rem' }}
									/>
									<span className="text-base text-gray-500">h</span>
								</div>
								<div className="flex items-center gap-1.5">
									<input type="number" min="0" max="59" value={benefitForm.duration_minute}
										onChange={e => this.setBenefitField('duration_minute', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
										onBlur={e => { if (benefitForm.duration_minute === '') this.setBenefitField('duration_minute', 0) }}
										className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
										style={{ width: '4.5rem' }}
									/>
									<span className="text-base text-gray-500">min</span>
								</div>
							</div>
						</div>

						<div className="mb-4">
							<label className="block text-base font-medium text-gray-700 mb-1.5">Intervalle entre les séances</label>
							<p className="text-base text-gray-400 mb-2">Temps de pause entre la fin d'une séance et le début de la suivante.</p>
							<div className="flex items-center gap-3">
								<div className="flex items-center gap-1.5">
									<input type="number" min="0" max="23" value={benefitForm.interval_hour}
										onChange={e => this.setBenefitField('interval_hour', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
										onBlur={e => { if (benefitForm.interval_hour === '') this.setBenefitField('interval_hour', 0) }}
										className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
										style={{ width: '4.5rem' }}
									/>
									<span className="text-base text-gray-500">h</span>
								</div>
								<div className="flex items-center gap-1.5">
									<input type="number" min="0" max="59" value={benefitForm.interval_minute}
										onChange={e => this.setBenefitField('interval_minute', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
										onBlur={e => { if (benefitForm.interval_minute === '') this.setBenefitField('interval_minute', 0) }}
										className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
										style={{ width: '4.5rem' }}
									/>
									<span className="text-base text-gray-500">min</span>
								</div>
							</div>
						</div>

						<hr className="border-gray-100 mb-4" />
					</div>
				)}

				{/* Section : Créneaux horaires */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Créneaux horaires</p>

				<div className="mb-5">

					{benefitForm.open_hours.length > 0 && (
						<div className="flex flex-col gap-2 mb-3">
							{benefitForm.open_hours.map((c, i) => {
								const isEditing = editingCreneauIndex === i
								const start = `${String(c.start_hour).padStart(2, '0')}:${String(c.start_minute).padStart(2, '0')}`
								const end = `${String(c.end_hour).padStart(2, '0')}:${String(c.end_minute).padStart(2, '0')}`
								const isInvalid = (() => {
									const duration = Number(benefitForm.duration_hour) * 60 + Number(benefitForm.duration_minute)
									return duration > 0 && this._computeSlotsForRange(c) === 0
								})()
								return (
									<div key={i} className={`flex items-center justify-between rounded-xl border px-4 py-3 ${isEditing ? 'border-indigo-400 bg-indigo-50' : isInvalid ? 'border-orange-300 bg-orange-50' : 'border-gray-200 bg-white'}`}>
										<div>
											<div className="flex gap-1.5 mb-1.5 flex-wrap">
												{DAYS.map(d => (
													<span key={d.key} className={`text-base px-2 py-0.5 rounded-md font-medium ${c[d.key] ? 'bg-indigo-100 text-indigo-700' : 'text-gray-300'}`}>
														{d.full}
													</span>
												))}
											</div>
											<p className="text-base font-semibold text-gray-700">{start} → {end}</p>
										{(() => {
											const duration = Number(benefitForm.duration_hour) * 60 + Number(benefitForm.duration_minute)
											if (duration === 0) return null
											const count = this._computeSlotsForRange(c)
											if (count === 0) {
												const rangeMins = (c.end_hour * 60 + c.end_minute) - (c.start_hour * 60 + c.start_minute)
												const dLabel = benefitForm.duration_hour > 0
													? `${benefitForm.duration_hour}h${benefitForm.duration_minute > 0 ? benefitForm.duration_minute : ''}`
													: `${benefitForm.duration_minute}min`
												const rLabel = Math.floor(rangeMins / 60) > 0
													? `${Math.floor(rangeMins / 60)}h${rangeMins % 60 > 0 ? rangeMins % 60 : ''}`
													: `${rangeMins}min`
												return <p className="text-sm text-orange-500 mt-1 font-medium">⚠ 0 créneau — durée {dLabel} &gt; plage {rLabel}</p>
											}
											return <p className="text-sm text-indigo-500 mt-1">→ {count} créneau{count > 1 ? 'x' : ''} par jour actif</p>
										})()}
										</div>
										<div className="flex items-center gap-1 ml-3 flex-shrink-0">
											{isEditing ? (
												<button type="button" onClick={this.cancelEditCreneau}
													className="text-base text-indigo-500 hover:text-indigo-700 font-medium px-2 py-1">
													Annuler
												</button>
											) : (
												<button type="button" onClick={() => this.editCreneau(i)}
													className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
													<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
														<path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
													</svg>
												</button>
											)}
											<button type="button" onClick={() => this.removeCreneau(i)}
												className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
												<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
													<path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
													</svg>
											</button>
										</div>
									</div>
								)
							})}
						</div>
					)}

					{showCreneauForm && (
						<div className={`rounded-xl p-4 border ${editingCreneauIndex !== null ? 'bg-indigo-50 border-indigo-300' : 'bg-gray-50 border-gray-200'}`}>
							<p className="text-base font-medium text-gray-500 mb-3">
								{editingCreneauIndex !== null ? `Modifier le créneau ${editingCreneauIndex + 1} :` : 'Nouveau créneau :'}
							</p>
							<div className="grid grid-cols-7 gap-1.5 mb-4">
								{DAYS.map(d => (
									<button key={d.key} type="button" onClick={() => this.toggleDay(d.key)}
										className={`py-2.5 rounded-full text-base font-semibold transition-colors ${
											creneauForm[d.key]
												? 'bg-indigo-600 text-white'
												: 'bg-white border border-gray-300 text-gray-600 hover:border-indigo-400'
										}`}>
										{d.full}
									</button>
								))}
							</div>
							<div className="flex items-end gap-3">
								<div className="flex-1">
									<p className="text-base text-gray-500 mb-1">De</p>
									<input type="time"
										value={`${String(creneauForm.start_hour).padStart(2, '0')}:${String(creneauForm.start_minute).padStart(2, '0')}`}
										onChange={e => {
											const parts = (e.target.value || '09:00').split(':')
											this.setState({ creneauForm: { ...creneauForm, start_hour: parseInt(parts[0]) || 0, start_minute: parseInt(parts[1]) || 0 } })
										}}
										className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
									/>
								</div>
								<span className="text-gray-400 pb-3.5">→</span>
								<div className="flex-1">
									<p className="text-base text-gray-500 mb-1">À</p>
									<input type="time"
										value={`${String(creneauForm.end_hour).padStart(2, '0')}:${String(creneauForm.end_minute).padStart(2, '0')}`}
										onChange={e => {
											const parts = (e.target.value || '10:00').split(':')
											this.setState({ creneauForm: { ...creneauForm, end_hour: parseInt(parts[0]) || 0, end_minute: parseInt(parts[1]) || 0 } })
										}}
										className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
									/>
								</div>
							</div>
							<div className="flex gap-2 mt-3">
								{editingCreneauIndex !== null && (
									<button type="button" onClick={this.cancelEditCreneau}
										className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-100">
										Annuler
									</button>
								)}
								<button type="button" onClick={this.addCreneau}
									className={`flex-1 py-2 rounded-lg border-2 border-dashed text-base font-medium ${editingCreneauIndex !== null ? 'border-indigo-400 text-indigo-700 hover:bg-indigo-100' : 'border-indigo-300 text-indigo-600 hover:bg-indigo-50'}`}>
									{editingCreneauIndex !== null ? '✓ Enregistrer les modifications' : '+ Ajouter ce créneau'}
								</button>
							</div>
						</div>
					)}
					{!showCreneauForm && (
						<button type="button" onClick={() => this.setState({ showCreneauForm: true, creneauForm: { ...EMPTY_CRENEAU }, editingCreneauIndex: null })}
							className="w-full py-2 rounded-lg border-2 border-dashed border-indigo-300 text-indigo-600 text-base font-medium hover:bg-indigo-50">
							+ Ajouter un créneau
						</button>
					)}
				</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Périodes d'ouverture */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Périodes d'ouverture</p>

				<div className="mb-5">

					{benefitForm.open_dates.length > 0 && (
						<div className="flex flex-col gap-2 mb-3">
							{benefitForm.open_dates.map((d, i) => (
								<div key={i} className={`flex items-center justify-between rounded-xl border px-4 py-3 ${editingDateIndex === i ? 'bg-emerald-50 border-emerald-300' : 'bg-white border-gray-200'}`}>
									<div className="flex items-center gap-4">
										<div>
											<p className="text-base text-gray-400 mb-0.5">Début</p>
											<p className="text-base font-semibold text-gray-800">{String(d.start_day).padStart(2, '0')} {MONTHS[d.start_month - 1]}</p>
										</div>
										<span className="text-gray-300 text-base">→</span>
										<div>
											<p className="text-base text-gray-400 mb-0.5">Fin</p>
											<p className="text-base font-semibold text-gray-800">{String(d.end_day).padStart(2, '0')} {MONTHS[d.end_month - 1]}</p>
										</div>
									</div>
									<div className="flex items-center gap-1 ml-3 flex-shrink-0">
										<button type="button" onClick={() => this.editDate(i)}
											className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
											<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
												<path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
											</svg>
										</button>
										<button type="button" onClick={() => this.removeDateRange(i)}
											className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
											<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
												<path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
											</svg>
										</button>
									</div>
								</div>
							))}
						</div>
					)}

					{showDateForm && (
						<div className={`rounded-xl p-4 border mb-3 ${editingDateIndex !== null ? 'bg-emerald-50 border-emerald-300' : 'bg-gray-50 border-gray-200'}`}>
							<p className="text-base font-medium text-gray-500 mb-3">
								{editingDateIndex !== null ? `Modifier la période ${editingDateIndex + 1} :` : 'Nouvelle période :'}
							</p>
							<div className="flex items-end gap-3">
								<div className="flex-1">
									<p className="text-base text-gray-500 mb-1.5">Début</p>
									<div className="flex gap-1.5">
										<div className="flex-1">
											<p className="text-base text-gray-400 mb-1 text-center">Jour</p>
											<input type="number" min="1" max="31" value={dateForm.start_day}
												onChange={e => {
													const raw = e.target.value
													if (raw === '') { this.setDateField('start_day', ''); return }
													const v = parseInt(raw)
													if (!isNaN(v)) this.setDateField('start_day', Math.min(31, v))
												}}
												onBlur={() => {
													const v = parseInt(dateForm.start_day)
													if (isNaN(v) || v < 1) this.setDateField('start_day', 1)
												}}
												className="w-full border border-gray-300 rounded-lg px-2 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
											/>
										</div>
										<div className="flex-1">
											<p className="text-base text-gray-400 mb-1 text-center">Mois</p>
											<input type="number" min="1" max="12" value={dateForm.start_month}
												onChange={e => {
													const raw = e.target.value
													if (raw === '') { this.setDateField('start_month', ''); return }
													const v = parseInt(raw)
													if (!isNaN(v)) this.setDateField('start_month', Math.min(12, v))
												}}
												onBlur={() => {
													const v = parseInt(dateForm.start_month)
													if (isNaN(v) || v < 1) this.setDateField('start_month', 1)
												}}
												className="w-full border border-gray-300 rounded-lg px-2 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
											/>
										</div>
									</div>
									<p className="text-base text-gray-400 mt-1 text-center">{MONTHS[(parseInt(dateForm.start_month) || 1) - 1]}</p>
								</div>
								<span className="text-gray-300 pb-8">→</span>
								<div className="flex-1">
									<p className="text-base text-gray-500 mb-1.5">Fin</p>
									<div className="flex gap-1.5">
										<div className="flex-1">
											<p className="text-base text-gray-400 mb-1 text-center">Jour</p>
											<input type="number" min="1" max="31" value={dateForm.end_day}
												onChange={e => {
													const raw = e.target.value
													if (raw === '') { this.setDateField('end_day', ''); return }
													const v = parseInt(raw)
													if (!isNaN(v)) this.setDateField('end_day', Math.min(31, v))
												}}
												onBlur={() => {
													const v = parseInt(dateForm.end_day)
													if (isNaN(v) || v < 1) this.setDateField('end_day', 1)
												}}
												className="w-full border border-gray-300 rounded-lg px-2 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
											/>
										</div>
										<div className="flex-1">
											<p className="text-base text-gray-400 mb-1 text-center">Mois</p>
											<input type="number" min="1" max="12" value={dateForm.end_month}
												onChange={e => {
													const raw = e.target.value
													if (raw === '') { this.setDateField('end_month', ''); return }
													const v = parseInt(raw)
													if (!isNaN(v)) this.setDateField('end_month', Math.min(12, v))
												}}
												onBlur={() => {
													const v = parseInt(dateForm.end_month)
													if (isNaN(v) || v < 1) this.setDateField('end_month', 1)
												}}
												className="w-full border border-gray-300 rounded-lg px-2 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
											/>
										</div>
									</div>
									<p className="text-base text-gray-400 mt-1 text-center">{MONTHS[(parseInt(dateForm.end_month) || 1) - 1]}</p>
								</div>
							</div>
							<div className="flex gap-2 mt-3">
								{editingDateIndex !== null && (
									<button type="button" onClick={this.cancelEditDate}
										className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-100">
										Annuler
									</button>
								)}
								<button type="button" onClick={this.addDateRange}
									className={`flex-1 py-2 rounded-lg border-2 border-dashed text-base font-medium ${editingDateIndex !== null ? 'border-emerald-400 text-emerald-700 hover:bg-emerald-100' : 'border-emerald-300 text-emerald-600 hover:bg-emerald-50'}`}>
									{editingDateIndex !== null ? '✓ Enregistrer les modifications' : '+ Ajouter cette période'}
								</button>
							</div>
						</div>
					)}
					{!showDateForm && (
						<button type="button" onClick={() => this.setState({ showDateForm: true, dateForm: { ...EMPTY_DATE } })}
							className="w-full py-2 rounded-lg border-2 border-dashed border-emerald-300 text-emerald-600 text-base font-medium hover:bg-emerald-50">
							+ Ajouter une période
						</button>
					)}
				</div>

				{/* Section : Créneaux de retrait (vente only) */}
				{isVente && (
					<div className="mb-4">
						<hr className="border-gray-100 mb-4" />
						<div className="flex items-start justify-between gap-4 mb-3">
							<div>
								<p className="text-base font-medium text-gray-700">Subdiviser en créneaux de retrait</p>
								<p className="text-base text-gray-400 mt-0.5">Par défaut, chaque plage horaire correspond à un seul créneau de retrait. Activez cette option pour proposer des sous-créneaux (ex : toutes les 30 min).</p>
							</div>
							<button type="button"
								onClick={() => {
									const next = !showVenteSubSlots
									if (next && benefitForm.open_hours.length > 0) {
										const oh = benefitForm.open_hours[0]
										const rangeMin = (oh.end_hour * 60 + oh.end_minute) - (oh.start_hour * 60 + oh.start_minute)
										this.setState({ showVenteSubSlots: true, benefitForm: { ...this.state.benefitForm, duration_hour: Math.floor(rangeMin / 60), duration_minute: rangeMin % 60 } })
									} else {
										this.setState({ showVenteSubSlots: next })
									}
								}}
								className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-0.5 focus:outline-none ${showVenteSubSlots ? 'bg-indigo-600' : 'bg-gray-200'}`}>
								<span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${showVenteSubSlots ? 'translate-x-5' : 'translate-x-0'}`} />
							</button>
						</div>
						{showVenteSubSlots && (
							<div className="rounded-xl bg-gray-50 border border-gray-200 px-4 py-4 mb-4">
								<div className="mb-4">
									<label className="block text-base font-medium text-gray-700 mb-1.5">Durée d'un créneau</label>
									<div className="flex items-center gap-3">
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="23" value={benefitForm.duration_hour}
												onChange={e => this.setBenefitField('duration_hour', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
												onBlur={e => { if (benefitForm.duration_hour === '') this.setBenefitField('duration_hour', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">h</span>
										</div>
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="59" value={benefitForm.duration_minute}
												onChange={e => this.setBenefitField('duration_minute', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
												onBlur={e => { if (benefitForm.duration_minute === '') this.setBenefitField('duration_minute', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">min</span>
										</div>
									</div>
								</div>
								<div>
									<label className="block text-base font-medium text-gray-700 mb-1.5">Intervalle entre les créneaux</label>
									<p className="text-base text-gray-400 mb-2">Temps de pause entre deux créneaux de retrait consécutifs.</p>
									<div className="flex items-center gap-3">
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="23" value={benefitForm.interval_hour}
												onChange={e => this.setBenefitField('interval_hour', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
												onBlur={e => { if (benefitForm.interval_hour === '') this.setBenefitField('interval_hour', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">h</span>
										</div>
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="59" value={benefitForm.interval_minute}
												onChange={e => this.setBenefitField('interval_minute', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
												onBlur={e => { if (benefitForm.interval_minute === '') this.setBenefitField('interval_minute', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">min</span>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				)}

				{/* Section : Paramètres de fermeture (vente only) */}
				{isVente && (
					<div>
						<hr className="border-gray-100 mb-4" />
						<div className="flex items-start justify-between gap-4 mb-3">
							<div>
								<p className="text-base font-medium text-gray-700">Paramètres de fermeture</p>
								<p className="text-base text-gray-400 mt-0.5">Définir des délais spécifiques pour ce créneau.</p>
							</div>
							<button type="button"
								onClick={() => this.setState({ showVenteDelays: !showVenteDelays })}
								className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-0.5 focus:outline-none ${showVenteDelays ? 'bg-indigo-600' : 'bg-gray-200'}`}>
								<span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${showVenteDelays ? 'translate-x-5' : 'translate-x-0'}`} />
							</button>
						</div>
						{showVenteDelays && (
							<div className="rounded-xl bg-gray-50 border border-gray-200 px-4 py-4 mb-4">
								<div className="mb-4">
									<label className="block text-base font-medium text-gray-700 mb-1.5">Fermeture des commandes</label>
									<p className="text-base text-gray-400 mb-2">Délai avant le créneau au-delà duquel les commandes et annulations ne sont plus possibles.</p>
									<div className="flex items-center gap-3">
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="999" value={benefitForm.limit_end_h}
												onChange={e => this.setBenefitField('limit_end_h', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
												onBlur={e => { if (benefitForm.limit_end_h === '') this.setBenefitField('limit_end_h', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">h</span>
										</div>
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="59" value={benefitForm.limit_end_m}
												onChange={e => this.setBenefitField('limit_end_m', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
												onBlur={e => { if (benefitForm.limit_end_m === '') this.setBenefitField('limit_end_m', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">min</span>
										</div>
									</div>
								</div>
								<div>
									<label className="block text-base font-medium text-gray-700 mb-1.5">Délai d'annulation</label>
									<p className="text-base text-gray-400 mb-2">Délai avant le créneau au-delà duquel les annulations seules ne sont plus possibles.</p>
									<div className="flex items-center gap-3">
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="999" value={benefitForm.cancel_limit_h}
												onChange={e => this.setBenefitField('cancel_limit_h', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
												onBlur={e => { if (benefitForm.cancel_limit_h === '') this.setBenefitField('cancel_limit_h', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">h</span>
										</div>
										<div className="flex items-center gap-1.5">
											<input type="number" min="0" max="59" value={benefitForm.cancel_limit_m}
												onChange={e => this.setBenefitField('cancel_limit_m', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
												onBlur={e => { if (benefitForm.cancel_limit_m === '') this.setBenefitField('cancel_limit_m', 0) }}
												className="w-18 border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
												style={{ width: '4.5rem' }}
											/>
											<span className="text-base text-gray-500">min</span>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				)}

				{benefitError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{benefitError}</div>
				)}

				{!this.state.editingBenefitId && (<div className="flex gap-3 mt-5">
					<button type="button" onClick={this.prevBenefitStep}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50">
						← Retour
					</button>
					<button type="button" onClick={this.nextBenefitStep}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-medium hover:bg-indigo-700">
						Suivant →
					</button>
				</div>)}
			</div>
		)
	}

	renderVenteParticipantsStep = () => {
		const { benefitForm, benefitLoading, benefitError, editingBenefitId, showQuestionForm, questionForm, editingQuestionIndex, icons, theme, current_lang } = this.state
		const tSummary = (benefitForm.translations || []).find(x => x.lang === current_lang) || {}
		const qt = (questionForm.translations || []).find(x => x.lang === current_lang) || { title: '' }
		return (
			<div>
				{/* Section : Informations client */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Informations client</p>
				<p className="text-base text-gray-400 mb-3">Champs demandés lors de la prise de commande.</p>
				<div className="flex flex-col gap-3 mb-6">
					{[
						{ key: 'identity', label: 'Identité', desc: 'Nom et prénom' },
						{ key: 'client_number', label: 'Numéro client', desc: 'Identifiant PMS' },
						{ key: 'age', label: 'Âge', desc: 'Âge du client' },
						{ key: 'phone', label: 'Téléphone', desc: 'Numéro de téléphone' },
					].map(({ key, label, desc }) => (
						<div key={key} className="flex items-center justify-between gap-4">
							<div>
								<p className="text-base font-medium text-gray-700">{label}</p>
								<p className="text-base text-gray-400">{desc}</p>
							</div>
							<button type="button"
								onClick={() => this.setBenefitField(key, !benefitForm[key])}
								className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-0.5 focus:outline-none ${benefitForm[key] ? 'bg-indigo-600' : 'bg-gray-200'}`}>
								<span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${benefitForm[key] ? 'translate-x-5' : 'translate-x-0'}`} />
							</button>
						</div>
					))}
				</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Questions */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Questions</p>
				<p className="text-base text-gray-400 mb-3">Les campeurs devront répondre lors de leur commande.</p>

				<div className="mb-5">
					{benefitForm.questions.map((q, i) => {
						const title = q.translations && q.translations[0] ? q.translations[0].title : ''
						const typeLabel = q.type === 'text' ? 'Texte' : q.type === 'number' ? 'Nombre' : ''
						return (
							<div key={i} className="flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 mb-2">
								<div>
									<p className="text-base font-medium text-gray-800">{title}</p>
									<p className="text-base text-gray-400 mt-0.5">{typeLabel}{q.mandatory ? ' · Obligatoire' : ''}</p>
								</div>
								<div className="flex items-center gap-1 ml-3 flex-shrink-0">
									<button type="button" onClick={() => this.editQuestion(i)}
										className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
										<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
											<path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
										</svg>
									</button>
									<button type="button" onClick={() => this.removeQuestion(i)}
										className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
										<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
											<path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
										</svg>
									</button>
								</div>
							</div>
						)
					})}

					{showQuestionForm && (
						<div className={`rounded-xl p-4 border mb-3 ${editingQuestionIndex !== null ? 'bg-indigo-50 border-indigo-300' : 'bg-gray-50 border-gray-200'}`}>
							<p className="text-base font-medium text-gray-500 mb-3">
								{editingQuestionIndex !== null ? `Modifier la question ${editingQuestionIndex + 1} :` : 'Nouvelle question :'}
							</p>
							<LangSelector lang={this.state.current_lang} updateLang={this.updateLang} />
							<div className="mb-3">
								<label className="block text-base font-medium text-gray-500 mb-1">Question</label>
								<input type="text" value={qt.title}
									onChange={e => this.setQuestionTranslation('title', e.target.value.slice(0, 50))}
									placeholder="ex : Avez-vous des allergies ?"
									className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
								/>
								<p className="text-base text-gray-400 mt-1 text-right">{qt.title.length}/50</p>
							</div>
							<div className="flex gap-3 mb-3">
								<div className="flex-1">
									<label className="block text-base font-medium text-gray-500 mb-1">Type de réponse</label>
									<div className="flex gap-2">
										{[{ key: 'text', label: 'Texte' }, { key: 'number', label: 'Nombre' }].map(t => (
											<button key={t.key} type="button"
												onClick={() => this.setState({ questionForm: { ...questionForm, type: t.key } })}
												className={`flex-1 py-2 rounded-lg text-base font-semibold border transition-colors ${questionForm.type === t.key ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white border-gray-300 text-gray-600 hover:border-indigo-400'}`}>
												{t.label}
											</button>
										))}
									</div>
								</div>
								<div className="flex flex-col items-start">
									<label className="block text-base font-medium text-gray-500 mb-1">Obligatoire</label>
									<button type="button"
										onClick={() => this.setState({ questionForm: { ...questionForm, mandatory: !questionForm.mandatory } })}
										className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-1.5 ${questionForm.mandatory ? 'bg-indigo-600' : 'bg-gray-200'}`}>
										<span className={`inline-block h-4 w-4 rounded-full bg-white shadow transform transition-transform ${questionForm.mandatory ? 'translate-x-4' : 'translate-x-0'}`} />
									</button>
								</div>
							</div>
							<button type="button" onClick={this.addQuestion}
								className={`w-full py-2 rounded-lg border-2 border-dashed text-base font-medium ${editingQuestionIndex !== null ? 'border-indigo-400 text-indigo-700 hover:bg-indigo-100' : 'border-indigo-300 text-indigo-600 hover:bg-indigo-50'}`}>
								{editingQuestionIndex !== null ? '✓ Enregistrer la modification' : '+ Ajouter cette question'}
							</button>
						</div>
					)}
					{!showQuestionForm && benefitForm.questions.length < 5 && (
						<button type="button" onClick={() => this.setState({ showQuestionForm: true })}
							className="w-full py-2 rounded-lg border-2 border-dashed border-indigo-300 text-indigo-500 text-base font-medium hover:bg-indigo-50">
							+ Ajouter une question
						</button>
					)}
				</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Résumé */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Résumé</p>
				<div className="bg-gray-50 rounded-xl border border-gray-100 p-4 mb-5 text-base space-y-3">
					<div className="flex flex-col gap-0.5">
						<span className="text-gray-400">Titre</span>
						<div className="flex items-center gap-2">
							{benefitForm.icon && icons && theme && (() => {
								const ic = icons.find(x => x._id === benefitForm.icon)
								let src = null
								if (ic && ic.fill) {
									for (let i = 0; i < ic.fill.length; i++) {
										if (ic.fill[i].theme === theme._id) { src = ic.fill[i].icon; break }
									}
									if (!src && ic.fill.length > 0) src = ic.fill[0].icon
								}
								return src ? <img src={src} alt="" className="w-5 h-5 object-contain flex-shrink-0" /> : null
							})()}
							<span className="font-medium text-gray-800">{tSummary.subtitle}</span>
						</div>
					</div>
					{tSummary.description ? (
						<div className="flex flex-col gap-0.5">
							<span className="text-gray-400">Description</span>
							<span className="font-medium text-gray-800 whitespace-pre-line">{tSummary.description}</span>
						</div>
					) : null}
					<div className="flex flex-col gap-0.5">
						<span className="text-gray-400">Créneaux horaires</span>
						<span className="font-medium text-gray-800">{benefitForm.open_hours.length} créneau{benefitForm.open_hours.length !== 1 ? 'x' : ''}</span>
					</div>
					<div className="flex flex-col gap-0.5">
						<span className="text-gray-400">Périodes d'ouverture</span>
						<span className="font-medium text-gray-800">{benefitForm.open_dates.length} période{benefitForm.open_dates.length !== 1 ? 's' : ''}</span>
					</div>
				</div>

				{benefitError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{benefitError}</div>
				)}

				{!this.state.editingBenefitId && (<div className="flex gap-3">
					<button type="button" onClick={this.prevBenefitStep} disabled={benefitLoading}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50 disabled:opacity-50">
						← Retour
					</button>
					<button type="button" onClick={this.submitBenefit} disabled={benefitLoading}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700 disabled:opacity-70 flex items-center justify-center gap-2">
						{benefitLoading ? (
							<>
								<svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
								</svg>
								Création...
							</>
						) : (editingBenefitId ? 'Enregistrer' : 'Créer le créneau')}
					</button>
				</div>)}
			</div>
		)
	}

		renderBenefitStep3 = () => {
		const { benefitForm, benefitError, service, workers } = this.state
		return (
			<div>
				{/* Section : Capacité */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Capacité</p>

				<div className="mb-4">
					<div className="flex items-start justify-between gap-4">
						<div>
							<p className="text-base font-medium text-gray-700">Limiter le nombre de places</p>
							<p className="text-base text-gray-400 mt-0.5">Les inscriptions seront limitées à un nombre de places défini.</p>
						</div>
						<button type="button"
							onClick={() => this.setBenefitField('participants_unlimited', !benefitForm.participants_unlimited)}
							className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-0.5 focus:outline-none ${!benefitForm.participants_unlimited ? 'bg-indigo-600' : 'bg-gray-200'}`}>
							<span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${!benefitForm.participants_unlimited ? 'translate-x-5' : 'translate-x-0'}`} />
						</button>
					</div>
					{!benefitForm.participants_unlimited && (
						<div className="flex items-center gap-2 mt-3">
							<input type="number" min="1" value={benefitForm.max_participants}
								onChange={e => this.setBenefitField('max_participants', e.target.value === '' ? '' : Math.max(1, parseInt(e.target.value) || 1))}
							onBlur={e => { if (benefitForm.max_participants === '') this.setBenefitField('max_participants', 1) }}
								className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
								style={{ width: '5rem' }}
							/>
							<span className="text-base text-gray-500">personnes max</span>
						</div>
					)}
				</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Équipe */}
				{service && service.type === 'prestation' && (
					<div className="mb-4">
						<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Équipe</p>
						{(!workers || workers.length === 0) ? (
							<p className="text-base text-gray-400 bg-amber-50 border border-amber-100 rounded-xl px-4 py-3">
								Aucun intervenant configuré. Un intervenant par défaut sera créé automatiquement, disponible toute l'année pour toutes les prestations.
							</p>
						) : (
							<div>
								<p className="text-base text-gray-400 mb-3">Sélectionnez les intervenants qui gèrent cette prestation. Si aucun n'est sélectionné, un intervenant par défaut couvrira toutes les prestations.</p>
								<div className="flex flex-col gap-2">
									{workers.map(w => {
										const isSelected = benefitForm.selectedWorkerIds.indexOf(w._id) !== -1
										const initials = ((w.firstname || '')[0] || '') + ((w.lastname || '')[0] || '')
										return (
											<button key={w._id} type="button"
												onClick={() => {
													const ids = [...benefitForm.selectedWorkerIds]
													const idx = ids.indexOf(w._id)
													if (idx === -1) ids.push(w._id)
													else ids.splice(idx, 1)
													this.setBenefitField('selectedWorkerIds', ids)
												}}
												className={`flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-colors ${isSelected ? 'bg-indigo-50 border-indigo-400' : 'bg-white border-gray-200 hover:border-indigo-300'}`}>
												<div className={`w-7 h-7 rounded-full flex items-center justify-center text-base font-bold flex-shrink-0 ${isSelected ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-600'}`}>
													{initials}
												</div>
												<span className="text-base font-medium text-gray-800 flex-1">{w.firstname} {w.lastname}</span>
												{isSelected && <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>}
											</button>
										)
									})}
								</div>
								{benefitForm.selectedWorkerIds.length === 0 && (
									<p className="text-base text-gray-400 mt-2">Aucun sélectionné — un intervenant par défaut sera utilisé.</p>
								)}
							</div>
						)}
					</div>
				)}

				{benefitError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{benefitError}</div>
				)}

				{!this.state.editingBenefitId && (<div className="flex gap-3">
					<button type="button" onClick={this.prevBenefitStep}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50">
						← Retour
					</button>
					<button type="button" onClick={this.nextBenefitStep}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700">
						Suivant →
					</button>
				</div>)}
			</div>
		)
	}

	renderBenefitStep4 = () => {
		const { benefitForm, benefitLoading, benefitError, editingBenefitId, showQuestionForm, questionForm, editingQuestionIndex, icons, theme, current_lang } = this.state
		const tSummary = (benefitForm.translations || []).find(x => x.lang === current_lang) || {}
		const qt = (questionForm.translations || []).find(x => x.lang === current_lang) || { title: '' }
		return (
			<div>
				<hr className="border-gray-100 mb-4" />

				{/* Section : Informations participant */}
				<div className="mb-4">
					<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Informations participant</p>
					<p className="text-base text-gray-400 mb-3">Champs demandés lors de la prise de réservation.</p>
					<div className="flex text-base flex-col gap-3">
						{[
							{ key: 'identity', label: 'Identité', desc: 'Nom et prénom' },
							{ key: 'client_number', label: 'Numéro client', desc: 'Identifiant PMS' },
							{ key: 'age', label: 'Âge', desc: 'Âge du participant' },
							{ key: 'phone', label: 'Téléphone', desc: 'Numéro de téléphone' },
						].map(({ key, label, desc }) => (
							<div key={key} className="flex items-center justify-between gap-4">
								<div>
									<p className="text-base font-medium text-gray-700">{label}</p>
									<p className="text-base text-gray-400">{desc}</p>
								</div>
								<button type="button"
									onClick={() => this.setBenefitField(key, !benefitForm[key])}
									className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-0.5 focus:outline-none ${benefitForm[key] ? 'bg-indigo-600' : 'bg-gray-200'}`}>
									<span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${benefitForm[key] ? 'translate-x-5' : 'translate-x-0'}`} />
								</button>
							</div>
						))}
					</div>
				</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Règles de réservation */}
				<div className="mb-4">
					<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Règles de réservation</p>
					<div className="flex flex-col gap-4">
						<div>
							<label className="block text-base font-medium text-gray-700 mb-1">Fermeture des inscriptions</label>
							<div className="flex items-center gap-2">
								<input
									type="number" min="0"
									value={benefitForm.limit_end_h}
									onChange={e => this.setBenefitField('limit_end_h', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
									onBlur={e => this.setBenefitField('limit_end_h', parseInt(e.target.value) >= 0 ? parseInt(e.target.value) : 0)}
									className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
									style={{ width: '4.5rem' }}
								/>
								<span className="text-base text-gray-500">h</span>
								<input
									type="number" min="0" max="59"
									value={benefitForm.limit_end_m}
									onChange={e => this.setBenefitField('limit_end_m', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
									onBlur={e => this.setBenefitField('limit_end_m', parseInt(e.target.value) >= 0 ? Math.min(59, parseInt(e.target.value)) : 0)}
									className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
									style={{ width: '4.5rem' }}
								/>
								<span className="text-base text-gray-500">min avant le début</span>
							</div>
						</div>
						<div>
							<label className="block text-base font-medium text-gray-700 mb-1">Délai d'annulation</label>
							<div className="flex items-center gap-2">
								<input
									type="number" min="0"
									value={benefitForm.cancel_limit_h}
									onChange={e => this.setBenefitField('cancel_limit_h', e.target.value === '' ? '' : Math.max(0, parseInt(e.target.value) || 0))}
									onBlur={e => this.setBenefitField('cancel_limit_h', parseInt(e.target.value) >= 0 ? parseInt(e.target.value) : 0)}
									className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
									style={{ width: '4.5rem' }}
								/>
								<span className="text-base text-gray-500">h</span>
								<input
									type="number" min="0" max="59"
									value={benefitForm.cancel_limit_m}
									onChange={e => this.setBenefitField('cancel_limit_m', e.target.value === '' ? '' : Math.min(59, Math.max(0, parseInt(e.target.value) || 0)))}
									onBlur={e => this.setBenefitField('cancel_limit_m', parseInt(e.target.value) >= 0 ? Math.min(59, parseInt(e.target.value)) : 0)}
									className="border border-gray-300 rounded-xl px-3 py-2.5 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
									style={{ width: '4.5rem' }}
								/>
								<span className="text-base text-gray-500">min avant le début</span>
							</div>
						</div>
					</div>
				</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Questions */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Questions</p>

				<div className="mb-5">
					<p className="text-base text-gray-400 mb-3">Les campeurs devront répondre lors de leur inscription.</p>

				{benefitForm.questions.map((q, i) => {
					const title = q.translations && q.translations[0] ? q.translations[0].title : ''
					const typeLabel = q.type === 'text' ? 'Texte' : q.type === 'number' ? 'Nombre' : ''
					return (
						<div key={i} className="flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 mb-2">
							<div>
								<p className="text-base font-medium text-gray-800">{title}</p>
								<p className="text-base text-gray-400 mt-0.5">{typeLabel}{q.mandatory ? ' · Obligatoire' : ''}</p>
							</div>
							<div className="flex items-center gap-1 ml-3 flex-shrink-0">
								<button type="button" onClick={() => this.editQuestion(i)}
									className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
									<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
										<path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
									</svg>
								</button>
								<button type="button" onClick={() => this.removeQuestion(i)}
									className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
									<svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
										<path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
									</svg>
								</button>
							</div>
						</div>
					)
				})}

				{showQuestionForm && (
					<div className={`rounded-xl p-4 border mb-3 ${editingQuestionIndex !== null ? 'bg-indigo-50 border-indigo-300' : 'bg-gray-50 border-gray-200'}`}>
						<p className="text-base font-medium text-gray-500 mb-3">
							{editingQuestionIndex !== null ? `Modifier la question ${editingQuestionIndex + 1} :` : 'Nouvelle question :'}
						</p>
						<LangSelector lang={this.state.current_lang} updateLang={this.updateLang} />
						<div className="mb-3">
							<label className="block text-base font-medium text-gray-500 mb-1">Question</label>
							<input type="text" value={qt.title}
								onChange={e => this.setQuestionTranslation('title', e.target.value.slice(0, 50))}
								placeholder="ex : Êtes-vous débutant ?"
								className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
							/>
							<p className="text-base text-gray-400 mt-1 text-right">{qt.title.length}/50</p>
						</div>
						<div className="flex gap-3 mb-3">
							<div className="flex-1">
								<label className="block text-base font-medium text-gray-500 mb-1">Type de réponse</label>
								<div className="flex gap-2">
									{[{ key: 'text', label: 'Texte' }, { key: 'number', label: 'Nombre' }].map(t => (
										<button key={t.key} type="button"
											onClick={() => this.setState({ questionForm: { ...questionForm, type: t.key } })}
											className={`flex-1 py-2 rounded-lg text-base font-semibold border transition-colors ${questionForm.type === t.key ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white border-gray-300 text-gray-600 hover:border-indigo-400'}`}>
											{t.label}
										</button>
									))}
								</div>
							</div>
							<div className="flex flex-col items-start">
								<label className="block text-base font-medium text-gray-500 mb-1">Obligatoire</label>
								<button type="button"
									onClick={() => this.setState({ questionForm: { ...questionForm, mandatory: !questionForm.mandatory } })}
									className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border-2 border-transparent transition-colors mt-1.5 ${questionForm.mandatory ? 'bg-indigo-600' : 'bg-gray-200'}`}>
									<span className={`inline-block h-4 w-4 rounded-full bg-white shadow transform transition-transform ${questionForm.mandatory ? 'translate-x-4' : 'translate-x-0'}`} />
								</button>
							</div>
						</div>
						<button type="button" onClick={this.addQuestion}
							className={`w-full py-2 rounded-lg border-2 border-dashed text-base font-medium ${editingQuestionIndex !== null ? 'border-indigo-400 text-indigo-700 hover:bg-indigo-100' : 'border-indigo-300 text-indigo-600 hover:bg-indigo-50'}`}>
							{editingQuestionIndex !== null ? '✓ Enregistrer la modification' : '+ Ajouter cette question'}
						</button>
					</div>
				)}

				{!showQuestionForm && benefitForm.questions.length < 5 && (
					<button type="button" onClick={() => this.setState({ showQuestionForm: true })}
						className="w-full py-2 rounded-lg border-2 border-dashed border-indigo-300 text-indigo-500 text-base font-medium hover:bg-indigo-50">
						+ Ajouter une question
					</button>
				)}
			</div>

				<hr className="border-gray-100 mb-4" />

				{/* Section : Résumé */}
				<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-3">Résumé</p>

				<div className="bg-gray-50 rounded-xl border border-gray-100 p-4 mb-5 text-base space-y-3">
					<div className="flex flex-col gap-0.5">
						<span className="text-gray-400">Titre</span>
						<div className="flex items-center gap-2">
							{benefitForm.icon && icons && theme && (() => {
								const ic = icons.find(x => x._id === benefitForm.icon)
								let src = null
								if (ic && ic.fill) {
									for (let i = 0; i < ic.fill.length; i++) {
										if (ic.fill[i].theme === theme._id) { src = ic.fill[i].icon; break }
									}
									if (!src && ic.fill.length > 0) src = ic.fill[0].icon
								}
								return src ? <img src={src} alt="" className="w-5 h-5 object-contain flex-shrink-0" /> : null
							})()}
							<span className="font-medium text-gray-800">{tSummary.subtitle}</span>
						</div>
					</div>
					{tSummary.description ? (
						<div className="flex flex-col gap-0.5">
							<span className="text-gray-400">Description</span>
							<span className="font-medium text-gray-800 whitespace-pre-line">{tSummary.description}</span>
						</div>
					) : null}
					<div className="flex flex-col gap-0.5">
						<span className="text-gray-400">Durée</span>
						<span className="font-medium text-gray-800">{benefitForm.duration_hour}h{String(benefitForm.duration_minute).padStart(2, '0')}</span>
					</div>
				</div>

				{benefitError && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{benefitError}</div>
				)}

				{!this.state.editingBenefitId && (<div className="flex gap-3">
					<button type="button" onClick={this.prevBenefitStep} disabled={benefitLoading}
						className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50 disabled:opacity-50">
						← Retour
					</button>
					<button type="button" onClick={this.submitBenefit} disabled={benefitLoading}
						className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700 disabled:opacity-70 flex items-center justify-center gap-2">
						{benefitLoading ? (
							<>
								<svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
								</svg>
								Création...
							</>
						) : (editingBenefitId ? 'Enregistrer' : 'Créer la prestation')}
					</button>
				</div>)}
			</div>
		)
	}

	// ─── Header edit ────────────────────────────────────────────────────────────

	openEditHeader = () => {
		const { service, current_lang } = this.state
		const lang = current_lang
		let name = service.name
		if (service.translations) {
			for (const t of service.translations)
				if (t.lang === lang && t.title) { name = t.title; break }
		}
		this.setState({
			editingHeader: true,
			headerForm: { name, cover: service.cover || '', product_images: service.product_images || false },
			headerError: null
		})
	}

	cancelEditHeader = () => {
		this.setState({ editingHeader: false, headerForm: { name: '', cover: '' }, headerError: null })
	}

	handleHeaderCover = (e) => {
		const file = e.target.files[0]
		if (!file) return
		const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']
		if (!allowedTypes.includes(file.type)) {
			this.setState({ headerError: 'Format non supporté (JPG, PNG, GIF uniquement)' })
			return
		}
		this.setState({ headerError: null })
		const reader = new FileReader()
		reader.onload = (ev) => {
			const img = new Image()
			img.onload = () => {
				const MAX = 1200
				const scale = img.width > MAX ? MAX / img.width : 1
				const canvas = document.createElement('canvas')
				canvas.width = Math.round(img.width * scale)
				canvas.height = Math.round(img.height * scale)
				canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height)
				const cover = canvas.toDataURL('image/jpeg', 0.75)
				this.setState({ headerForm: { ...this.state.headerForm, cover } })
			}
			img.src = ev.target.result
		}
		reader.readAsDataURL(file)
	}

	saveHeader = () => {
		const { service, headerForm } = this.state
		if (!headerForm.name.trim()) {
			this.setState({ headerError: 'Le nom est requis.' })
			return
		}
		if (!headerForm.cover) {
			this.setState({ headerError: 'Une photo de couverture est requise.' })
			return
		}
		this.setState({ headerLoading: true, headerError: null })
		const lang = this.state.current_lang
		const existing = (service.translations || [])
		const hasLang = existing.some(t => t.lang === lang)
		const translations = hasLang
			? existing.map(t => t.lang === lang ? { ...t, title: headerForm.name } : t)
			: [...existing, { lang, title: headerForm.name }]
		const updated = {
			...service,
			name: headerForm.name,
			cover: headerForm.cover,
			translations,
			comment: service.comment || null,
			list_mode: service.list_mode || false,
			product_images: headerForm.product_images || false,
			user: this.props.user._id
		}
		this.props.updateService(updated)
		.then(ret => {
			this.setState({ service: ret, editingHeader: false, headerLoading: false, headerForm: { name: '', cover: '' } })
		})
		.catch(() => {
			this.setState({ headerLoading: false, headerError: 'Une erreur s\'est produite.' })
		})
	}

	// Enregistre le mode de paiement in-app du service : "cb_only", "cb_optional"
	// ou null (paiement sur place uniquement — défaut).
	setPaymentMode = (mode) => {
		const { service } = this.state
		const current = (service.payment_mode != null) ? service.payment_mode : null
		if (current === mode || this.state.paymentModeLoading) return
		this.setState({ paymentModeLoading: true, paymentModeError: null })
		const updated = {
			...service,
			comment: service.comment || null,
			list_mode: service.list_mode || false,
			product_images: service.product_images || false,
			payment_mode: mode,
			user: this.props.user._id
		}
		this.props.updateService(updated)
		.then(ret => {
			if (!ret)
			{
				this.setState({ paymentModeLoading: false, paymentModeError: 'Une erreur s\'est produite. Veuillez réessayer.' })
				return ;
			}
			this.setState({ service: ret, paymentModeLoading: false })
		})
		.catch(() => {
			this.setState({ paymentModeLoading: false, paymentModeError: 'Une erreur s\'est produite. Veuillez réessayer.' })
		})
	}

	// Active/désactive le montant minimum du panier pour proposer la CB
	// en mode "cb_optional". Désactiver enregistre 0 (pas de minimum).
	togglePaymentMinimum = () => {
		if (this.state.paymentMinLoading)
			return
		const { service } = this.state
		const enabled = (this.state.paymentMinEnabled != null) ? this.state.paymentMinEnabled : (Number(service.payment_minimum) > 0)
		if (enabled)
		{
			this.setState({ paymentMinEnabled: false, paymentMinInput: null, paymentMinError: null })
			if (Number(service.payment_minimum) > 0)
				this.savePaymentMinimum(0)
		}
		else
			this.setState({ paymentMinEnabled: true, paymentMinError: null })
	}

	// Enregistre le montant minimum (en euros). 0 = option désactivée.
	savePaymentMinimum = (value) => {
		const { service } = this.state
		let amount = Number(String(value).replace(',', '.'))
		if (isNaN(amount) || amount < 0)
			amount = 0
		amount = Math.round(amount * 100) / 100
		const current = (service.payment_minimum != null) ? Number(service.payment_minimum) : 0
		if (current === amount || this.state.paymentMinLoading)
			return
		const currentMax = (service.payment_maximum != null) ? Number(service.payment_maximum) : 0
		if (currentMax > 0 && amount > currentMax)
		{
			this.setState({ paymentMinError: 'Le montant minimum ne peut pas dépasser le montant maximum.' })
			return
		}
		this.setState({ paymentMinLoading: true, paymentMinError: null })
		const updated = {
			...service,
			comment: service.comment || null,
			list_mode: service.list_mode || false,
			product_images: service.product_images || false,
			payment_minimum: amount,
			user: this.props.user._id
		}
		this.props.updateService(updated)
		.then(ret => {
			if (!ret)
			{
				this.setState({ paymentMinLoading: false, paymentMinError: 'Une erreur s\'est produite. Veuillez réessayer.' })
				return ;
			}
			this.setState({ service: ret, paymentMinLoading: false, paymentMinEnabled: null, paymentMinInput: null })
		})
		.catch(() => {
			this.setState({ paymentMinLoading: false, paymentMinError: 'Une erreur s\'est produite. Veuillez réessayer.' })
		})
	}

	togglePaymentMaximum = () => {
		if (this.state.paymentMaxLoading)
			return
		const { service } = this.state
		const enabled = (this.state.paymentMaxEnabled != null) ? this.state.paymentMaxEnabled : (Number(service.payment_maximum) > 0)
		if (enabled)
		{
			this.setState({ paymentMaxEnabled: false, paymentMaxInput: null, paymentMaxError: null })
			if (Number(service.payment_maximum) > 0)
				this.savePaymentMaximum(0)
		}
		else
			this.setState({ paymentMaxEnabled: true, paymentMaxError: null })
	}

	// Enregistre le montant maximum (en euros). 0 = option désactivée.
	savePaymentMaximum = (value) => {
		const { service } = this.state
		let amount = Number(String(value).replace(',', '.'))
		if (isNaN(amount) || amount < 0)
			amount = 0
		amount = Math.round(amount * 100) / 100
		const current = (service.payment_maximum != null) ? Number(service.payment_maximum) : 0
		if (current === amount || this.state.paymentMaxLoading)
			return
		const currentMin = (service.payment_minimum != null) ? Number(service.payment_minimum) : 0
		if (amount > 0 && currentMin > amount)
		{
			this.setState({ paymentMaxError: 'Le montant maximum ne peut pas être inférieur au montant minimum.' })
			return
		}
		this.setState({ paymentMaxLoading: true, paymentMaxError: null })
		const updated = {
			...service,
			comment: service.comment || null,
			list_mode: service.list_mode || false,
			product_images: service.product_images || false,
			payment_maximum: amount,
			user: this.props.user._id
		}
		this.props.updateService(updated)
		.then(ret => {
			if (!ret)
			{
				this.setState({ paymentMaxLoading: false, paymentMaxError: 'Une erreur s\'est produite. Veuillez réessayer.' })
				return ;
			}
			this.setState({ service: ret, paymentMaxLoading: false, paymentMaxEnabled: null, paymentMaxInput: null })
		})
		.catch(() => {
			this.setState({ paymentMaxLoading: false, paymentMaxError: 'Une erreur s\'est produite. Veuillez réessayer.' })
		})
	}

	// ─── Render ───────────────────────────────────────────────────────────────────

	render() {
		const {
			service, benefits, workers, loading, pageError,
			showBenefitWizard, benefitStep,
			showWorkerForm, workerForm, workerLoading, workerError,
			editingWorkerId, workerEditForm, workerEditLoading, workerEditError,
			deleteConfirm, editingBenefitId
		} = this.state
		const isVente = service && service.type === 'vente'

		if (loading) {
			return (
				<div className="flex items-center justify-center min-h-screen">
					<Loader />
				</div>
			)
		}

		if (pageError || !service) {
			return (
				<div className="flex flex-col items-center justify-center min-h-screen text-gray-500">
					<p>{pageError || 'Service introuvable.'}</p>
					<Link to="/services" className="mt-4 text-indigo-600 hover:underline text-base">← Retour aux services</Link>
				</div>
			)
		}

		const isPrestation = service.type === 'prestation'
		const lang = this.state.current_lang

		let serviceTitle = service.name
		if (service.translations) {
			for (const t of service.translations)
				if (t.lang === lang && t.title) { serviceTitle = t.title; break }
		}

		return (
			<div className="min-h-screen bg-gray-100 py-8 px-4">
				<div className="max-w-2xl mx-auto">

					{/* Back */}
					<button
						onClick={() => this.props.history.push('/services')}
						className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800 transition-colors mb-6"
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
						</svg>
						Retour aux services
					</button>

					{/* Header */}
					<div className="bg-white rounded-2xl shadow-sm overflow-hidden mb-6">
						{this.state.editingHeader ? (
							<div className="wizard-card">
								{/* Zone image cliquable avec overlay */}
								<div
									className="relative cursor-pointer"
									onClick={() => this.coverInputRef.current && this.coverInputRef.current.click()}
								>
									{this.state.headerForm.cover ? (
										<img src={this.state.headerForm.cover} alt="" className="w-full h-48 object-cover" />
									) : (
										<div className="w-full h-48 bg-gray-50" />
									)}
									<div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5" style={{ backgroundColor: 'rgba(255,255,255,0.65)' }}>
										<svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
											<path strokeLinecap="round" strokeLinejoin="round" d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
											<polyline points="17 8 12 3 7 8" />
											<line x1="12" y1="3" x2="12" y2="15" />
										</svg>
										<p className="font-bold text-gray-800 text-base">{this.state.headerForm.cover ? 'Changer la photo' : 'Ajouter une photo'}</p>
										<p className="text-sm text-gray-500">JPG, PNG, GIF · Max 5 Mo</p>
									</div>
								</div>
								<input
									ref={this.coverInputRef}
									type="file"
									accept="image/jpeg,image/png,image/gif"
									className="hidden"
									onChange={this.handleHeaderCover}
								/>
								{this.state.headerError && (
									<p className="text-sm text-red-600 px-5 pt-2">{this.state.headerError}</p>
								)}
								<div className="p-5">
									<LangSelector lang={this.state.current_lang} updateLang={this.updateLang} />
									<label className="block text-base font-medium text-gray-700 mb-1.5">Nom du service</label>
									<input type="text" value={this.state.headerForm.name}
										onChange={e => this.setState({ headerForm: { ...this.state.headerForm, name: e.target.value.slice(0, 50) }, headerError: null })}
										className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
										maxLength={50}
									/>
									{!isPrestation && (
										<div className="flex items-center justify-between mt-4">
											<div>
												<p className="text-base font-medium text-gray-700">Photos des articles</p>
												<p className="text-sm text-gray-400">Afficher une photo sur chaque article du catalogue.</p>
											</div>
											<button
												type="button"
												onClick={() => this.setState({ headerForm: { ...this.state.headerForm, product_images: !this.state.headerForm.product_images } })}
												style={{ backgroundImage: 'none', backgroundColor: 'transparent', flexShrink: 0 }}
											>
												<span style={{ display: 'inline-flex', width: '44px', height: '24px', borderRadius: '12px', background: this.state.headerForm.product_images ? '#4f46e5' : '#d1d5db', alignItems: 'center', padding: '2px', transition: 'background 0.2s' }}>
													<span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'white', transform: this.state.headerForm.product_images ? 'translateX(20px)' : 'translateX(0)', transition: 'transform 0.2s' }} />
												</span>
											</button>
										</div>
									)}
									<div className="flex gap-3 mt-4">
										<button type="button" onClick={this.cancelEditHeader}
											className="flex-1 py-2 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50">
											Annuler
										</button>
										<button type="button" onClick={this.saveHeader}
											disabled={this.state.headerLoading || !this.state.headerForm.cover}
											className="flex-1 py-2 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed">
											{this.state.headerLoading ? 'Enregistrement...' : 'Enregistrer'}
										</button>
									</div>
								</div>
							</div>
						) : (
							<>
								{service.cover && (
									<img src={service.cover} alt={serviceTitle} className="w-full h-48 object-cover" />
								)}
								<div className="p-5">
									<div className="flex items-start justify-between">
										<div>
											<span className={`inline-flex items-center gap-1 text-base font-semibold px-3 py-1 rounded-full mb-3 ${isPrestation ? 'bg-indigo-100 text-indigo-700' : 'bg-orange-100 text-orange-700'}`}>
												{isPrestation ? '🎯 Activité ou événement' : '🛒 Commande'}
											</span>
											<h1 className="text-xl font-bold text-gray-900">{serviceTitle}</h1>
										</div>
										<button type="button" onClick={this.openEditHeader}
											className="ml-4 mt-1 p-1.5 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
											title="Modifier le nom et la photo">
											<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
										</button>
									</div>
								</div>
							</>
						)}
					</div>

					{/* Paiement en ligne (compte Stripe actif) */}
					{this.state.stripe_ready && (
						<div className="bg-white rounded-2xl shadow-sm overflow-hidden mb-6">
							<div className="px-5 py-4 border-b border-gray-100">
								<h2 className="text-base font-bold text-gray-900">Paiement en ligne</h2>
								<p className="text-base text-gray-400 mt-0.5">Choisissez comment les vacanciers règlent leurs commandes sur ce service.</p>
							</div>
							<div className="divide-y divide-gray-50">
								{[
									{ value: null, label: 'Paiement sur place uniquement', desc: 'Pas de paiement CB dans l\'application (TPE, espèces…).' },
									{ value: 'cb_optional', label: 'Au choix du vacancier', desc: 'Payer par CB dans l\'application ou sur place.' },
									{ value: 'cb_only', label: 'CB obligatoire', desc: isVente ? '100% des commandes réglées par CB dans l\'application.' : '100% des réservations payantes réglées par CB dans l\'application.' }
								].map(opt => {
									const current = (service.payment_mode != null) ? service.payment_mode : null
									const selected = current === opt.value
									const minEnabled = (this.state.paymentMinEnabled != null) ? this.state.paymentMinEnabled : (Number(service.payment_minimum) > 0)
									const minValue = (this.state.paymentMinInput != null) ? this.state.paymentMinInput : ((Number(service.payment_minimum) > 0) ? String(service.payment_minimum) : '')
									const maxEnabled = (this.state.paymentMaxEnabled != null) ? this.state.paymentMaxEnabled : (Number(service.payment_maximum) > 0)
									const maxValue = (this.state.paymentMaxInput != null) ? this.state.paymentMaxInput : ((Number(service.payment_maximum) > 0) ? String(service.payment_maximum) : '')
									return (
										<React.Fragment key={String(opt.value)}>
											<button type="button" onClick={() => this.setPaymentMode(opt.value)}
												disabled={this.state.paymentModeLoading}
												className={`w-full px-5 py-4 flex items-center justify-between text-left transition-colors disabled:opacity-60 ${selected ? 'bg-indigo-50' : 'hover:bg-gray-50'}`}>
												<div>
													<p className={`text-base font-semibold ${selected ? 'text-indigo-700' : 'text-gray-900'}`}>{opt.label}</p>
													<p className="text-base text-gray-400 mt-0.5">{opt.desc}</p>
												</div>
												<div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ml-4 ${selected ? 'border-indigo-600' : 'border-gray-300'}`}>
													{selected && <div className="w-2.5 h-2.5 rounded-full bg-indigo-600" />}
												</div>
											</button>
											{opt.value === 'cb_optional' && selected && (
												<div className="px-5 py-4 bg-indigo-50">
													<div className="flex items-center justify-between gap-4 pl-4 border-l-2 border-indigo-200">
														<div>
															<p className="text-base font-semibold text-gray-900">Montant minimum</p>
															<p className="text-base text-gray-400 mt-0.5">En dessous de ce total, le paiement CB n'est pas proposé : règlement sur place uniquement.</p>
														</div>
														<button type="button" onClick={this.togglePaymentMinimum}
															disabled={this.state.paymentMinLoading}
															style={{ backgroundImage: 'none', backgroundColor: 'transparent', flexShrink: 0 }}>
															<span style={{ display: 'inline-flex', width: '44px', height: '24px', borderRadius: '12px', background: minEnabled ? '#4f46e5' : '#d1d5db', alignItems: 'center', padding: '2px', transition: 'background 0.2s' }}>
																<span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'white', transform: minEnabled ? 'translateX(20px)' : 'translateX(0)', transition: 'transform 0.2s' }} />
															</span>
														</button>
													</div>
													{minEnabled && (
														<div className="wizard-card flex items-center gap-2 mt-3 pl-4">
															<input type="number" min="0" step="0.01" value={minValue}
																onChange={(e) => this.setState({ paymentMinInput: e.target.value })}
																onKeyDown={(e) => { if (e.key === 'Enter') this.savePaymentMinimum(minValue) }}
																className="w-28 px-3 py-2 rounded-xl border border-gray-300 text-base bg-white"
																placeholder="0" />
															<span className="text-base text-gray-500">€</span>
															<button type="button" onClick={() => this.savePaymentMinimum(minValue)}
																disabled={this.state.paymentMinLoading}
																className="ml-2 px-4 py-2 rounded-xl bg-indigo-600 text-white text-base font-semibold hover:bg-indigo-700 disabled:opacity-50">
																{this.state.paymentMinLoading ? 'Enregistrement...' : 'Enregistrer'}
															</button>
														</div>
													)}
													{this.state.paymentMinError && (
														<p className="text-sm text-red-600 mt-2 pl-4">{this.state.paymentMinError}</p>
													)}
													<div className="flex items-center justify-between gap-4 pl-4 border-l-2 border-indigo-200 mt-4">
														<div>
															<p className="text-base font-semibold text-gray-900">Montant maximum</p>
															<p className="text-base text-gray-400 mt-0.5">Au-dessus de ce total, le paiement CB est imposé : le règlement sur place n'est plus proposé.</p>
														</div>
														<button type="button" onClick={this.togglePaymentMaximum}
															disabled={this.state.paymentMaxLoading}
															style={{ backgroundImage: 'none', backgroundColor: 'transparent', flexShrink: 0 }}>
															<span style={{ display: 'inline-flex', width: '44px', height: '24px', borderRadius: '12px', background: maxEnabled ? '#4f46e5' : '#d1d5db', alignItems: 'center', padding: '2px', transition: 'background 0.2s' }}>
																<span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'white', transform: maxEnabled ? 'translateX(20px)' : 'translateX(0)', transition: 'transform 0.2s' }} />
															</span>
														</button>
													</div>
													{maxEnabled && (
														<div className="wizard-card flex items-center gap-2 mt-3 pl-4">
															<input type="number" min="0" step="0.01" value={maxValue}
																onChange={(e) => this.setState({ paymentMaxInput: e.target.value })}
																onKeyDown={(e) => { if (e.key === 'Enter') this.savePaymentMaximum(maxValue) }}
																className="w-28 px-3 py-2 rounded-xl border border-gray-300 text-base bg-white"
																placeholder="0" />
															<span className="text-base text-gray-500">€</span>
															<button type="button" onClick={() => this.savePaymentMaximum(maxValue)}
																disabled={this.state.paymentMaxLoading}
																className="ml-2 px-4 py-2 rounded-xl bg-indigo-600 text-white text-base font-semibold hover:bg-indigo-700 disabled:opacity-50">
																{this.state.paymentMaxLoading ? 'Enregistrement...' : 'Enregistrer'}
															</button>
														</div>
													)}
													{this.state.paymentMaxError && (
														<p className="text-sm text-red-600 mt-2 pl-4">{this.state.paymentMaxError}</p>
													)}
												</div>
											)}
										</React.Fragment>
									)
								})}
							</div>
							{this.state.paymentModeError && (
								<p className="text-sm text-red-600 px-5 pb-4">{this.state.paymentModeError}</p>
							)}
						</div>
					)}

					{/* Prestations */}
					<div className="bg-white rounded-2xl shadow-sm overflow-hidden mb-6">
						<div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
							<h2 className="text-base font-bold text-gray-900">Prestations</h2>
							{!showBenefitWizard && (
								<button type="button" onClick={this.openBenefitWizard}
									className="inline-flex items-center gap-1 text-base font-medium text-indigo-600 hover:text-indigo-700">
									<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
										<path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
									</svg>
									Ajouter
								</button>
							)}
						</div>

						{/* Liste des prestations */}
						{(!benefits || benefits.length === 0) && !showBenefitWizard ? (
							<div className="px-5 py-10 text-center">
								<p className="text-gray-400 text-base">Aucune prestation configurée.</p>
								<p className="text-gray-400 text-base mt-1">Ajoutez une prestation pour que ce service soit réservable.</p>
							</div>
						) : (
							<div className="divide-y divide-gray-50">
								{(benefits || []).map(b => {
									const subtitle = this.getTitle(b.translations)
									const dur = `${b.duration_hour}h${String(b.duration_minute || 0).padStart(2, '0')}`
									const nCreneaux = (b.open_hours || []).length
									return (
										<div key={b._id} className={`px-5 py-4 flex items-center justify-between relative transition-colors ${editingBenefitId === b._id ? 'bg-indigo-50' : ''}`}>
										{editingBenefitId === b._id && <div className="absolute left-0 top-0 bottom-0 w-1 bg-indigo-500" />}
											<div>
												<p className="text-base font-semibold text-gray-900">{subtitle}</p>
												<p className="text-base text-gray-400 mt-0.5">
													{dur} · {nCreneaux} créneau{nCreneaux > 1 ? 'x' : ''} · {b.price ? `${b.price} €` : 'Gratuit'}
												</p>
											</div>
											<div className="flex items-center gap-2">
												{deleteConfirm === b._id ? (
													<div className="flex items-center gap-2 text-base">
														<button type="button" onClick={() => this.deleteBenefit(b._id)} className="font-semibold text-red-600 hover:text-red-700">Confirmer</button>
														<button type="button" onClick={() => this.setState({ deleteConfirm: null })} className="text-gray-400 hover:text-gray-600">Annuler</button>
													</div>
												) : (
													<div className="flex items-center gap-1">
														<button type="button" onClick={() => this.openEditBenefitWizard(b)}
															className="p-1.5 text-gray-400 hover:text-indigo-600 rounded-lg hover:bg-indigo-50">
															<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
																<path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
															</svg>
														</button>
														<button type="button" onClick={() => this.setState({ deleteConfirm: b._id })}
															className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
															<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
																<path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
															</svg>
														</button>
													</div>
												)}
											</div>
										</div>
									)
								})}
							</div>
						)}

						{/* Wizard inline */}
						{showBenefitWizard && (
							<div className="wizard-card border-t border-gray-100 p-5">
								{editingBenefitId && (() => {
									const eb = (benefits || []).find(b => b._id === editingBenefitId)
									const ebTitle = eb ? this.getTitle(eb.translations) : ''
									return ebTitle ? (
										<div className="flex items-center gap-2 mb-4">
											<span className="inline-flex items-center gap-1.5 text-base font-medium text-indigo-700 bg-indigo-50 border border-indigo-200 rounded-full px-3 py-1">
												<svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
												{ebTitle}
											</span>
										</div>
									) : null
								})()
								}
								{/* Progress bar */}
								<div className="flex items-center mb-5">
									{(isVente ? ['L\'essentiel', 'Produits', 'Créneaux', 'Client'] : ['L\'essentiel', 'Créneaux', 'Capacité', 'Participants']).map((label, i) => {
										const n = i + 1
										const active = n === benefitStep
										const done = n < benefitStep
										return (
											<React.Fragment key={n}>
												{i > 0 && <div className={`h-0.5 flex-1 mx-1 ${done ? 'bg-indigo-600' : 'bg-gray-200'}`} />}
												<div onClick={() => editingBenefitId && this.goToBenefitStep(n)} title={editingBenefitId ? ('Aller à : ' + label) : undefined} className={'flex flex-col items-center gap-0.5 ' + (editingBenefitId ? 'cursor-pointer' : '')}>
													<div className={`w-7 h-7 rounded-full flex items-center justify-center text-base font-semibold flex-shrink-0 ${active ? 'bg-indigo-600 text-white' : done ? 'bg-indigo-100 text-indigo-600' : 'bg-gray-100 text-gray-400'}`}>
														{done ? '✓' : n}
													</div>
													<span className={`text-base ${active ? 'text-indigo-600 font-medium' : 'text-gray-400'}`}>{label}</span>
												</div>
											</React.Fragment>
										)
									})}
								</div>
								<div className="border-t border-gray-100 pt-5">
									{benefitStep === 1 && this.renderBenefitStep1()}
									{benefitStep === 2 && (isVente ? this.renderProductsStep() : this.renderBenefitStep2())}
									{benefitStep === 3 && (isVente ? this.renderBenefitStep2() : this.renderBenefitStep3())}
									{benefitStep === 4 && (isVente ? this.renderVenteParticipantsStep() : this.renderBenefitStep4())}
										{/* Barre de sauvegarde permanente (mode édition uniquement) */}
										{editingBenefitId && (
											<div className="border-t border-gray-100 mt-6 pt-5 flex gap-3">
												<button type="button" onClick={this.closeBenefitWizard} disabled={this.state.benefitLoading}
													style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
													className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50 disabled:opacity-50">
													Annuler
												</button>
												<button type="button" onClick={this.submitBenefit} disabled={this.state.benefitLoading}
													style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
													className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-bold hover:bg-indigo-700 disabled:opacity-70 flex items-center justify-center gap-2">
													{this.state.benefitLoading ? (
														<>
															<svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
																<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
																<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
															</svg>
															Enregistrement...
														</>
													) : 'Enregistrer les modifications'}
												</button>
											</div>
										)}
								</div>
							</div>
						)}
					</div>

					{/* Équipe (prestation uniquement) */}
					{isPrestation && (
						<div className="bg-white rounded-2xl shadow-sm overflow-hidden mb-6">
							<div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
								<h2 className="text-base font-bold text-gray-900">Équipe</h2>
								{!showWorkerForm && (
									<button type="button" onClick={this.openWorkerForm}
										className="inline-flex items-center gap-1 text-base font-medium text-indigo-600 hover:text-indigo-700">
										<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
											<path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
										</svg>
										Ajouter
									</button>
								)}
							</div>

							{(!workers || workers.length === 0) && !showWorkerForm ? (
								<div className="px-5 py-10 text-center">
									<p className="text-gray-400 text-base">Aucun intervenant configuré.</p>
								</div>
							) : (
								<div className="divide-y divide-gray-50">
									{(workers || []).map(w => (
										<div key={w._id}>
											<div className={`px-5 py-3.5 flex items-center justify-between transition-colors ${editingWorkerId === w._id ? 'bg-indigo-50' : ''}`}>
												<div className="flex items-center gap-3">
													<div className="w-9 h-9 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-base font-bold flex-shrink-0">
														{((w.firstname || '')[0] || '') + ((w.lastname || '')[0] || '')}
													</div>
													<div>
														<p className="text-base font-medium text-gray-900">{w.firstname} {w.lastname}</p>
														{w.working_dates && w.working_dates.length > 0 && (
															<p className="text-base text-gray-400 mt-0.5">
																{w.working_dates.map((d, i) => (
																	<span key={i}>{i > 0 ? ' · ' : ''}{MONTHS[d.start_month - 1]} → {MONTHS[d.end_month - 1]}</span>
																))}
															</p>
														)}
													</div>
												</div>
												<div className="flex items-center gap-1">
													<button type="button" onClick={() => editingWorkerId === w._id ? this.closeEditWorker() : this.openEditWorker(w)}
														className={`p-1.5 rounded-lg transition-colors ${editingWorkerId === w._id ? 'text-indigo-600 bg-indigo-100' : 'text-gray-400 hover:text-indigo-600 hover:bg-indigo-50'}`}>
														<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
															<path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
														</svg>
													</button>
													<button type="button" onClick={() => this.deleteWorker(w._id)}
														className="p-1.5 text-gray-400 hover:text-red-500 rounded-lg hover:bg-red-50">
														<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
															<path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
														</svg>
													</button>
												</div>
											</div>

											{editingWorkerId === w._id && workerEditForm && (
												<div className="wizard-card border-t border-indigo-100 bg-indigo-50 px-5 py-5">

													{/* Prénom / Nom */}
													<div className="flex gap-3 mb-5">
														<div className="flex-1">
															<label className="block text-base font-semibold text-gray-500 mb-1">Prénom</label>
															<input type="text" value={workerEditForm.firstname}
																onChange={e => this.setWorkerEditField('firstname', e.target.value)}
																className="w-full border border-gray-300 rounded-xl px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
															/>
														</div>
														<div className="flex-1">
															<label className="block text-base font-semibold text-gray-500 mb-1">Nom</label>
															<input type="text" value={workerEditForm.lastname}
																onChange={e => this.setWorkerEditField('lastname', e.target.value)}
																className="w-full border border-gray-300 rounded-xl px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
															/>
														</div>
													</div>

													{/* Disponibilités */}
													<p className="text-base font-semibold text-gray-500 uppercase tracking-wide mb-2">Disponibilités</p>
													{workerEditForm.working_dates.map((d, i) => (
														<div key={i} className="bg-white rounded-xl border border-gray-200 px-4 py-3 mb-2 flex items-center gap-2 flex-wrap">
															<span className="text-base text-gray-400 w-4">Du</span>
															<select value={d.start_day} onChange={e => this.setWorkerDate(i, 'start_day', Number(e.target.value))}
																style={{ width: '62px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																{Array.from({ length: 31 }, (_, n) => n + 1).map(n => (
																	<option key={n} value={n}>{n < 10 ? '0' + n : n}</option>
																))}
															</select>
															<select value={d.start_month} onChange={e => this.setWorkerDate(i, 'start_month', Number(e.target.value))}
																style={{ width: '72px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																{MONTHS.map((m, idx) => <option key={idx + 1} value={idx + 1}>{m}</option>)}
															</select>
															<span className="text-base text-gray-400">→</span>
															<select value={d.end_day} onChange={e => this.setWorkerDate(i, 'end_day', Number(e.target.value))}
																style={{ width: '62px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																{Array.from({ length: 31 }, (_, n) => n + 1).map(n => (
																	<option key={n} value={n}>{n < 10 ? '0' + n : n}</option>
																))}
															</select>
															<select value={d.end_month} onChange={e => this.setWorkerDate(i, 'end_month', Number(e.target.value))}
																style={{ width: '72px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																{MONTHS.map((m, idx) => <option key={idx + 1} value={idx + 1}>{m}</option>)}
															</select>
															{workerEditForm.working_dates.length > 1 && (
																<button type="button" onClick={() => this.removeWorkerDate(i)}
																	className="ml-auto p-1 text-gray-400 hover:text-red-500 rounded">
																	<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
																		<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
																	</svg>
																</button>
															)}
														</div>
													))}
													<button type="button" onClick={this.addWorkerDate}
														className="text-base text-indigo-600 hover:text-indigo-700 font-medium mb-5">
														+ Ajouter une période
													</button>

													{/* Horaires */}
													<p className="text-base font-semibold text-gray-500 uppercase tracking-wide mb-2">Horaires de travail</p>
													{workerEditForm.working_hours.map((h, i) => (
														<div key={i} className="bg-white rounded-xl border border-gray-200 px-4 py-3 mb-2">
															<div className="flex items-center gap-1.5 mb-3">
																{DAYS.map(day => (
																	<button key={day.key} type="button"
																		onClick={() => this.toggleWorkerDay(i, day.key)}
																		className={`w-8 h-8 rounded-full text-base font-semibold border transition-colors ${h[day.key] ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white text-gray-500 border-gray-200'}`}>
																		{day.label}
																	</button>
																))}
																{workerEditForm.working_hours.length > 1 && (
																	<button type="button" onClick={() => this.removeWorkerHour(i)}
																		className="ml-auto p-1 text-gray-400 hover:text-red-500 rounded">
																		<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
																			<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
																		</svg>
																	</button>
																)}
															</div>
															<div className="flex items-center gap-2 flex-wrap">
																<span className="text-base text-gray-400">De</span>
																<select value={h.start_hour} onChange={e => this.setWorkerHour(i, 'start_hour', Number(e.target.value))}
																	style={{ width: '68px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																	{Array.from({ length: 24 }, (_, n) => n).map(n => (
																		<option key={n} value={n}>{n < 10 ? '0' + n : n}h</option>
																	))}
																</select>
																<select value={h.start_minute} onChange={e => this.setWorkerHour(i, 'start_minute', Number(e.target.value))}
																	style={{ width: '58px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																	{[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(n => (
																		<option key={n} value={n}>{n < 10 ? '0' + n : n}</option>
																	))}
																</select>
																<span className="text-base text-gray-400">→</span>
																<select value={h.end_hour} onChange={e => this.setWorkerHour(i, 'end_hour', Number(e.target.value))}
																	style={{ width: '68px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																	{Array.from({ length: 24 }, (_, n) => n).map(n => (
																		<option key={n} value={n}>{n < 10 ? '0' + n : n}h</option>
																	))}
																</select>
																<select value={h.end_minute} onChange={e => this.setWorkerHour(i, 'end_minute', Number(e.target.value))}
																	style={{ width: '58px' }} className="border border-gray-200 rounded-lg px-2 py-1.5 text-base">
																	{[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(n => (
																		<option key={n} value={n}>{n < 10 ? '0' + n : n}</option>
																	))}
																</select>
															</div>
														</div>
													))}
													<button type="button" onClick={this.addWorkerHour}
														className="text-base text-indigo-600 hover:text-indigo-700 font-medium mb-5">
														+ Ajouter un créneau horaire
													</button>

													{/* Prestations */}
													{benefits && benefits.length > 0 && (
														<div className="mb-5">
															<p className="text-base font-semibold text-gray-500 uppercase tracking-wide mb-2">Prestations associées</p>
															<p className="text-base text-gray-400 mb-3">Vide = disponible pour toutes les prestations</p>
															<div className="flex flex-col gap-2">
																{benefits.map(b => {
																	const title = this.getTitle(b.translations)
																	const checked = workerEditForm.services.indexOf(b._id) !== -1
																	return (
																		<label key={b._id} className="flex items-center gap-3 cursor-pointer">
																			<div className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors ${checked ? 'bg-indigo-600 border-indigo-600' : 'bg-white border-gray-300'}`}
																				onClick={() => this.toggleWorkerService(b._id)}>
																				{checked && (
																					<svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
																						<path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
																					</svg>
																				)}
																			</div>
																			<span className="text-base text-gray-700">{title}</span>
																		</label>
																	)
																})}
															</div>
														</div>
													)}

													{workerEditError && (
														<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{workerEditError}</div>
													)}
													<div className="flex gap-3">
														<button type="button" onClick={this.closeEditWorker}
															className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50 bg-white">
															Annuler
														</button>
														<button type="button" onClick={this.submitEditWorker} disabled={workerEditLoading}
															className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-medium hover:bg-indigo-700 disabled:opacity-70">
															{workerEditLoading ? 'Enregistrement...' : 'Enregistrer'}
														</button>
													</div>
												</div>
											)}
										</div>
									))}
								</div>
							)}

							{showWorkerForm && (
								<div className="wizard-card border-t border-gray-100 p-5">
									<p className="text-base font-semibold text-gray-700 mb-3">Nouvel intervenant</p>
									<div className="flex gap-3 mb-3">
										<input type="text" value={workerForm.firstname}
											onChange={e => this.setState({ workerForm: { ...workerForm, firstname: e.target.value } })}
											placeholder="Prénom"
											className="flex-1 border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
										/>
										<input type="text" value={workerForm.lastname}
											onChange={e => this.setState({ workerForm: { ...workerForm, lastname: e.target.value } })}
											placeholder="Nom"
											className="flex-1 border border-gray-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
										/>
									</div>
									{workerError && (
										<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-3 text-base text-red-700">{workerError}</div>
									)}
									<div className="flex gap-3">
										<button type="button" onClick={this.closeWorkerForm}
											className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-600 text-base font-medium hover:bg-gray-50">
											Annuler
										</button>
										<button type="button" onClick={this.submitWorker} disabled={workerLoading}
											className="flex-1 py-2.5 rounded-xl bg-indigo-600 text-white text-base font-medium hover:bg-indigo-700 disabled:opacity-70">
											{workerLoading ? 'Ajout...' : 'Ajouter'}
										</button>
									</div>
								</div>
							)}
						</div>
					)}

				</div>
			</div>
		)
	}
}

export default ServiceDetail
